<template>
	<div class="page-journal">
		<header-page
			:button-delete="!openMobile"
			search-header
			:button-filter="!openMobile"
			:button-close="openMobile"
			:title="$route.meta.title"
			to-show
			:show-excel="false"
			:show-clean="false"
			:code-journal="codeDetailJournal"
			:date-journal="dateDetailJournal"
			:detail-journal-open="detailJournalOpen"
			tabindex="-1"
			@delete-journal="deleteJournal"
			@delete-action="onClickIcon"
			@on-search-event="onSearch"
			@run-action="runAction"
			@click-close="closeMobile"
			@click-filter="clickFilter"
		></header-page>
		<div v-if="loadingData" class="jr-cargando-overlay">
	<div class="jr-cargando">
		<div class="jr-cargando__aro">
			<span class="jr-cargando__icono">
				<v-icon>table_chart</v-icon>
			</span>
		</div>
		<p class="jr-cargando__titulo">Cargando información</p>
		<p class="jr-cargando__texto">
			Estamos leyendo tu archivo de Excel, esto toma unos segundos.
		</p>
		<div class="jr-cargando__barra"></div>
	</div>
</div>
		<v-layout tabindex="-1">
			<v-flex>
				<v-alert
				:value="!currentSubsidiary.id" type="warning">
					Seleccione una empresa
				</v-alert>
			</v-flex>
		</v-layout>
<div v-if="currentSubsidiary.id" class="filters-wrapper">
    <div class="filters-bar">
      <!-- Título con ícono y fondo destacado -->
      <div class="filter-title-section">
        <v-icon small color="#33cfc7" class="mr-1">filter_list</v-icon>
        <span class="filter-title">Filtros aplicados ---></span>
      </div>

      <!-- Cada filtro como badge colorido -->
      <div class="filter-pill">
        <span class="filter-label">Desde:</span>
        <span class="filter-value">{{ params.startDate || 'Todos' }}</span>
      </div>

      <div class="filter-pill">
        <span class="filter-label">Hasta:</span>
        <span class="filter-value">{{ params.endDate || 'Todos' }}</span>
      </div>

      <div class="filter-pill">
        <span class="filter-label">Estado de Asiento:</span>
        <span class="filter-value">{{ getSquareLabel(params.status) }}</span>
      </div>

      <div class="filter-pill">
        <span class="filter-label">Tipo de Asiento:</span>
        <span class="filter-value">{{ getSquareLabel(params.square) }}</span>
      </div>

      <div class="filter-pill">
        <span class="filter-label">Origen</span>
        <span class="filter-value">{{ getModuleLabel(moduleName) }}</span>
      </div>
    </div>
  </div>
		<v-layout wrap pb-4>
			<v-flex
				xs12 md6 class="content-journal-heading"
				v-if="journalList && !openMobile && currentSubsidiary.id"
				tabindex="-1"
			>
				<journal-list
					:check-all="checkAll"
					:current-page="currentPage"
					:last-page="table.lastPage"
					:rows="table.rows || []"
					tabindex="-1"
					:items-total-quantity="table.itemTotal"
					:items-quantity="table.rows && table.rows.length > 0 ? table.rows.length : 0"
					:loading="loading"
					:can-create="canCreate"
					:can-edit="canUpdate"
					:can-delete="canDelete"
					@add-icon="createAction"
					@clear-filter="clearFilter"
					@click-icon="onClickIcon"
					@create-action="createAction"
					@delete-seat="runAction"
					@confirm-seat="saveAccouting"
					@detail-journal-list="mobileDetail"
					@on-page="onPage"
					@on-search="onSearch"
					@on-selected-all="onSelectedAll"
					@on-table-option="onTableOption"
					@open-detail="openDetail"
					@row-is-selected="rowIsSelected"
					@clone-seat="cloneSeat"
					@print-seat="printSeat"
					@detail-document="detailDocument"
				></journal-list>
			</v-flex>
			<v-flex
				xs12 md5
				class="content-detail"
				:class="{ 'open': openMobile }"
				v-if="currentSubsidiary.id"
			>
				<!-- Formulario para nuevo asiento -->
				<v-layout row wrap v-if="showSeatForm">
						<v-flex xs12 class="title-heading pt-1">
							Nuevo asiento
						</v-flex>
						<v-flex xs12 class="body-seat-form">
							<v-layout row wrap align-end>
								<v-flex xs12 sm4 pr-2  style="position: relative;">
									<v-select
										class="filter-select shadow-inset select-autocomplete-create"
										v-if="modules.length > 0"
										disabled
										hide-details
										:items="modulesFilter"
										item-text="name"
										item-value="id"
										placeholder="Origen"
										:readonly="modules.length === 0 || modules.length === 1"
										single-line
										:value="moduleValue"
										return-object
										:tabindex="modules.length === 0 || modules.length === 1 ? -1 : 1"
										@input="setModuleData"
									></v-select>
									<span
											class="caption error--text"
											style="position: absolute; bottom: -18px; left: 12px;"
											v-if="!this.model.moduleCode"
										>
												El modulo es requerido
										</span>
								</v-flex>
								<v-flex xs12 sm5 style="position: relative;">
										<app-input-text
											model="gloss"
											:id="modules.length === 0 || modules.length === 1 ? 'focus-new-seat' : ''"
											placeholder="Descripción"
											:tabindex="modules.length === 0 || modules.length === 1 ? 1 : 2"
											:text="model.gloss"
											@input="setModelData"
										></app-input-text>
										<span
											class="caption error--text"
											style="position: absolute; bottom: -18px; left: 12px;"
											v-if="!model.gloss"
										>
											La descripción es requerida
										</span>
										</v-flex>
								<v-flex xs6 sm3 pl-2>
									<date-component
										:date="model.date"
										icon="/static/img/calendar.svg"
										placeholder="Fecha"
										:tabindex="modules.length === 0 || modules.length === 1 ? 2 : 3"
										@on-input="setModelData({ model: 'date', value: $event })"
									></date-component>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 class="title-heading pt-1">
							Detalles
						</v-flex>
						<v-flex xs12 class="body-seat-form">
							<v-layout row wrap align-start>
								<v-flex xs12 sm8 pt-1>
									<multiselect
										v-model="accountingAccount"
										:options="accounts"
										label="fullName"
										track-by="id"
										id="focus-added"
										class="filter-select-custom"
										:select-label="''"
										:limit="100"
										:selected-label="''"
										:deselect-label="''"
										placeholder="Seleccione una cuenta"
										:tabindex="modules.length === 0 || modules.length === 1 ? 3 : 4"
										@select="setData">
										<template slot="option" slot-scope="props">
											<div
												:class="{
													'item-list-disabled': settings && settings
													.stat && props.option.stat === 1 }">
												{{ props.option.fullName }}
											</div>
										</template>
									</multiselect>
									<!-- <autocomplete-component
										append-icon="expand_more"
										http-code="$http"
										id="focus-added"
										:item="accountingAccount"
										item-text="fullName"
										item-value="id"
										:items="accounts"
										model="accountingAccount"
										autocomplete
										placeholder-value="Buscar cuenta contable"
										placeholder-input="Nombre de la cuenta"
										prop="account"
										prop-search="fullName"
										:readonly-prop="accountingAccount.name"
										readonly-prop-show
										:resource-url="`accounting-plan/${params.subsidiaryId}/subsidiary?status=1`"
										return-object
										select-create
										:tabindex="modules.length === 0 || modules.length === 1 ? 3 : 4"
										@return-data="setData"
									></autocomplete-component> -->
								</v-flex>
								<v-flex xs6 sm4 pl-2>
									<app-input-text
										model="reference"
										placeholder="Referencia"
										:tabindex="modules.length === 0 || modules.length === 1 ? 4 : 5"
										:text="modelDetail.reference"
										@input="setModelData"
									></app-input-text>
								</v-flex>
								<v-flex xs6 sm4 pr-2>
									<app-input-text
										model="concept"
										placeholder="Concepto"
										:tabindex="modules.length === 0 || modules.length === 1 ? 5 : 6"
										:text="modelDetail.concept"
										@input="setModelData"
									></app-input-text>
								</v-flex>
								<v-flex xs12 sm4>
									<autocomplete-component
										append-icon="expand_more"
										http-code="$http"
										:item="modelDetail.costCenterId"
										item-text="name"
										item-value="id"
										:items="costCenters"
										model="costCenterId"
										:show-clear="true"
										placeholder-value="Centro de costos"
										prop="name"
										prop-search="name"
										:resource-url="`cost-center/${params.subsidiaryId}/subsidiary`"
										return-object
										select-create
										:tabindex="modules.length === 0 || modules.length === 1 ? 6 : 7"
										@return-data="setCostCenter"
									></autocomplete-component>
								</v-flex>
								<v-flex xs6 sm2 pl-2>
									<app-input-text
										model="amount"
										:text="modelDetail.amount"
										:tabindex="modules.length === 0 || modules.length === 1 ? 7 : 8"
										tooltip-message="Ingresar el importe con signo negativo (-) para crear detalles de tipo HABER"
										tooltip-on-focused
										type="number"
										placeholder="0.00"
										@input="setModelData"
									></app-input-text>
									<span
										v-if="Number(modelDetail.amount) !== 0"
										:class="`${modelDetail.amount < 0 ? 'error' : 'secondary'}--text caption`">
										Detalle de tipo {{ typeDetail }}
									</span>
								</v-flex>
								<v-flex xs6 sm1 text-xs-center>
									<app-tooltip-button
										v-if="canCreate"
										class="no-movil"
										icon="add_circle_outline"
										:text="validInsertCostCenter
											? 'Debe seleccionar un Centro de Costo'
											: disabledBtnAdd
												? 'Verifique que los campos necesarios estén llenos'
												: 'Agregar'"
										color="#33cfc7"
										:disabled="disabledBtnAdd || validInsertCostCenter"
										@click-icon="addDetail"
									></app-tooltip-button>
								</v-flex>
							</v-layout>
						</v-flex>
				</v-layout>
				<v-layout v-if="showSeatForm">
					<journal-detail-add
						created-add
						:accounts="accounts"
						:balance="balance"
						:code-journal="codeJournal"
						:cost-centers="costCenters"
						:flagSquareSeats="flagSquareSeats"
						:credit="credit"
						:debit="debit"
						:details="dataSelected"
						:disabled-form-clean="disabledFormClean"
						:disabled-form-save="disabledFormSave"
						:edit-detail-inline="editDetailInline"
						:not-declare="notDeclare"
						:row-detail="rowDetail"
						:row-selected="rowSelected"
						:show-seat-form="showSeatForm"
						:subsidiary-id="params.subsidiaryId"
						:accounting-account="accountingAccount"
						:settings="settings"
						tabindex="-1"
						:to-declare="toDeclare"
						:model-detail="modelDetail"
						:modules="modules"
						:open-detail-seat="openDetailSeat"
						:valid-button="validButtonCostCenter"
						:can-create="canCreate"
						:can-edit="canUpdate"
						:can-delete="canDelete"
						@add-icon="createDetailSeat"
						@clean-all="cleanAll"
						@click-icon="onAction"
						@create-action="createDetailSeat"
						@edit-detail-inline="inlineEditDetail"
						@get-data="setDataDetail"
						@on-click="onClick"
						@on-search="onSearchDetail"
						@open-searcher="openSearcher"
						@save-all="onSaveMultiple"
						@set-data-account="setData"
						@set-cost-center="setCostCenter"
						@set-model-data="setModelData"
						@add-detail="saveDetailSeat"
						@remove-item="removeItem"
						@add-detail-seat="addDetailSeat"
						@import-excel="importExcel"
						@download-format="onDownloadFormat"
					/>
				</v-layout>
				<!-- Tabla para detalle de Asiento -->
				<journal-detail
					v-if="!showSeatForm"
					created-add
					:accounts="accounts"
					:flag-edit-inline="flagEditInline"
					:balance="balance || seccionHeader.balance"
					:code-journal="codeJournal"
					:cost-centers="costCenters"
					:credit="credit"
					:debit="debit"
					:flagDisabledAddSeat="flagDisabledAddSeat"
					:details="dataSelected"
					:disabled-form-clean="disabledFormClean"
					:disabled-form-save="disabledFormSave"
					:edit-detail-inline="editDetailInline"
					:not-declare="notDeclare"
					:row-detail="rowDetail"
					:row-selected="rowSelected"
					:show-seat-form="showSeatForm"
					:subsidiary-id="params.subsidiaryId"
					:accounting-account="accountingAccount"
					tabindex="-1"
					:to-declare="toDeclare"
					:model-detail="modelDetail"
					:modules="modules"
					:open-detail-seat="openDetailSeat"
					:settings="settings"
					:flag-valid="flagValidCostCenter"
					:valid-button="validButtonCostCenter"
					:is-loading="loading"
					:square-amounts="isSquareAmounts"
					:transaction-blocking-module="transactionBlockingModule"
					:can-create="canCreate"
					:can-edit="canUpdate"
					:can-delete="canDelete"
					@add-icon="createDetailSeat"
					@clean-all="cancelEditionDetail"
					@click-icon="onAction"
					@create-action="createDetailSeat"
					@edit-detail-inline="inlineEditDetail"
					@get-data="setDataDetail"
					@on-click="onClick"
					@on-search="onSearchDetail"
					@open-searcher="openSearcher"
					@save-all="onSaveMultiple"
					@set-data-account="setData"
					@change-date="changeDate"
					@set-cost-center="setCostCenter"
					@set-model-data="setModelData"
					@add-detail="saveNewDetailSeat"
					@add-detail-seat="addDetailSeat"
					@save-all-details="saveAllDetailsEdits"
				/>
			</v-flex>
		</v-layout>
		<action-bar
			class="action-mobile"
			:value-disabled="actionsDisabled"
			:resource-uri="$route.name"
			tabindex="-1"
			@run-action="runAction"
		/>
		<action-sidebar
			:img-src="action.imgSrc"
			tabindex="-1"
			:title="action.title"
			:value="action.value"
			:width="action.width"
			@close-modal="closeModal"
		>
			<slide-searcher
				v-if="isActionCode('searcher')"
				:columns="columns"
				:current-page="currentPageRecords"
				:last-page="lastPage"
				:rows="records"
				@add-record="addRecord"
				@on-close="closeModal"
				@on-page="changePageRecords"
				@on-search="onSearchRecords"
			/>
			<journal-filter-by
				v-if="isActionCode('filter-by')"
				:code="params.code"
				:end-date="params.endDate"
				:flag-cost-center="params.flagCostCenter"
				:start-date="params.startDate"
				:type-register-id="params.typeRegisterId"
				:states="states"
				:status="params.status"
				@close-modal="closeModal"
				@filter-by="filterBy"
			/>
			<journal-cancel-form
				v-if="isActionCode('cancel')"
				:loading="loading"
				:name="rowName"
				@close-modal="closeModal"
				@confirm-cancel="confirmCancel"
			/>
			<journal-detail-delete-form
				v-if="isActionCode('delete')"
				:loading="loading"
				:name="rowDetailName"
				:seat-name="rowName"
				@close-modal="closeModal"
				@on-delete="onDeleteDetailSeat"
			/>
			<journal-seat-form
				v-if="isActionCode('new-seat')"
				:customer="currentSubsidiary.customer"
				:loading="loading"
				:model="model"
				:modules="modules"
				:module-value="moduleValue"
				:subsidiary-id="currentSubsidiary.id"
				@close-modal="closeModal"
				@save="onSave"
				@set-module-data="setModuleData"
			/>
			<journal-detail-form
				v-if="isActionCode('new-detail-seat')"
				:loading="loading"
				:subsidiary-id="params.subsidiaryId"
				:model="model"
				@close-modal="closeModal"
				@save="onSaveDetail"
			/>
			<button
				slot="options"
				class="btn-clear-filter"
				@click="clearFilterMobile"
				v-if="isActionCode('filter-by')"
			>Limpiar Filtro</button>
		</action-sidebar>
		<v-dialog
			content-class="confirmation-dialog"
			v-model="cancelModal"
			max-width="400"
		>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">¿Desea eliminar los asientos seleccionados?</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<button
						type="button"
						class="btn-modal cancel mr-2"
						@click="setId">
						No
					</button>
					<button
						type="button"
						class="btn-modal save ml-2"
						@click="onDeleteSeat">
						Si
					</button>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="showPreviewClone"
			max-width="790"
			persistent
		>
			<preview-clone
				v-if="dataSeatClone && dataSeatClone.details && dataSeatClone.details.length > 0 && modules.length > 0"
				:data-seat="dataSeatClone"
				:accounts="accounts"
				:cost-centers="costCenters"
				:settings="settings"
				:modules="modules"
				:guardando="savingClone"
				:subsidiary-id="params.subsidiaryId"
				@save-clone="confirmClone"
				@close="closePreview">
			</preview-clone>
		</v-dialog>
		<input
			type="file"
			ref="fileInput"
			@change="handleFileUpload"
			style="display: none"
		/>
		<v-dialog
			v-model="showDialog"
			max-width="450"
			persistent>
			<v-card>
				<v-card-text class="card-container">
					<div class="card-container-title">
						<close-icon class="cursor-pointer" @click="closeAlert"></close-icon>
					</div>
					<div class="card-container-list">
						<span>En el documento exportado las siguientes cuentas no se encuentran dentro del plan de cuentas:</span> <br>
						<ul v-for="(item, index) in valuesNotFound" :key="index">
							<li>{{ item }}</li>
						</ul> <br>
						<span>Y las filas se omitieron.</span>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="showDetails"
			persistent
			width="650">
			<v-card class="card-container-details" v-if="showDetails">
				<v-card-title class="card-container-details-title">
					<span>Detalle Registro</span>
					<close-icon class="cursor-pointer" @click="closeDetailDocument"></close-icon>
				</v-card-title>
				<v-card-text class="card-container-details-list">
					<v-layout wrap>
						<v-flex xs6 mb-2 px-1 body-1>
							<v-layout>
								<v-flex class="content-green">N° Documento: </v-flex>
								<v-flex class="c-text-green">{{ detailsRegister.documentNumber }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 mb-2 px-1 body-1>
							<v-layout>
								<v-flex class="content-green">Módulo Origen: </v-flex>
								<v-flex class="c-text-green">{{ detailsRegister.moduleCode }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 mb-2 px-1 body-1>
							<v-layout>
								<v-flex class="content-green">Fecha Registro: </v-flex>
								<v-flex class="c-text-green">{{ detailsRegister.data.dateEmission || detailsRegister.data.paymentDate | exactDate }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 mb-2 px-1 body-1>
							<v-layout>
								<v-flex class="content-green">Monto: </v-flex>
								<v-flex class="c-text-green">${{ detailsRegister.data.amount }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 mb-2 px-1 body-1 v-if="detailsRegister.moduleCode !== 'BANCO' && detailsRegister.moduleCode !== 'CAJA'">
							<v-layout>
								<v-flex class="content-green">{{ getLabelRegister().label }}: </v-flex>
								<v-flex class="c-text-green">{{ getLabelRegister().value }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 mb-2 px-1 body-1>
							<v-layout>
								<v-flex class="content-green">Tipo de Pago: </v-flex>
								<v-flex class="c-text-green">{{ detailsRegister.data.typePayment && detailsRegister.data.typePayment.name
									? detailsRegister.data.typePayment.name
									: detailsRegister.data.transactions
										&& detailsRegister.data.transactions.length > 0
										&& detailsRegister.data.transactions[0].typePayment
										&& detailsRegister.data.transactions[0].typePayment.name
										? detailsRegister.data.transactions[0].typePayment.name
										: '' }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 mb-2 px-1 body-1 v-if="detailsRegister.moduleCode === 'CTAXPAG' || detailsRegister.moduleCode === 'CTAXCOB'">
							<v-layout>
								<v-flex class="content-green">Tipo de Trans: </v-flex>
								<v-flex class="c-text-green">{{ detailsRegister.data.typeAmortizationName }}</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="showItemsBlock"
			persistent
			width="500">
			<v-card class="card-container-blocked">
				<v-card-text class="card-container-blocked-text">
					<p class="card-container-blocked-text-title">Asientos bloqueados por cierre de periodo:</p>
					<div class="card-container-blocked-text-list">
						<div
							v-for="(item, index) in itemsBlockedPeriod"
							:key="index"
							class="card"
							>
							<div class="card-header">
								<h3 class="card-title">Asiento: {{ item.code }}</h3>
							</div>
							<div class="card-body">
								<span class="card-description">Descripción: {{ item.gloss }}</span>
								<span class="card-description">Fecha: {{ item.date | exactDate }}</span>
								<span class="card-description">Módulo: {{ item.moduleName }}</span>
							</div>
						</div>
					</div>
				</v-card-text>
				<v-card-actions class="card-container-blocked-actions">
					<button
						type="button"
						class="btn-modal save"
						@click="closItemsBlock">
						Aceptar
					</button>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import actionBar from '@/components/shared/action-bar/action-bar';
	import actionSidebar from '@/components/shared/action-sidebar';
	import appInputText from '@/components/autocomplete/app-input-text';
	import autocompleteComponent from '@/components/autocomplete/autocomplete-component';
	import dateComponent from '@/components/autocomplete/date-component';
	import helper from '@/shared/helper';
	import headerContent from '@/components/shared/header-content';
	import journalCancelForm from '@/components/journal/journal-cancel-form';
	import journalDetail from '@/components/journal/journal-detail';
	import journalDetailAdd from '@/components/journal/journal-detail-add';
	import journalDetailDeleteForm from '@/components/journal/journal-detail-delete-form';
	import journalFilter from '@/components/journal/journal-filter';
	import journalDetailForm from '@/components/journal/journal-detail-form';
	import journalFilterBy from '@/components/journal/journal-filter-by';
	import appTooltipButton from '@/components/shared/app-tooltip-button';
	import journalList from '@/components/journal/journal-list';
	import journalSeatForm from '@/components/journal/journal-seat-form';
	import slideSearcher from '@/components/shared/searcher/slide-searcher';
	import previewClone from '@/components/journal/preview-clone-seat';
	import lib from '@/shared/lib';
	import codeModules from '@/shared/codeModules';
	import { saveAs } from 'file-saver';
	import * as XLSX from 'xlsx';
	import { addHours, format, isBefore, isEqual } from 'date-fns';
	import closeIcon from '../../components/shared/icons/close.icon';

	const { exactDate } = helper;

	// ===== Permisos (parametrización) =====
	// Recurso ACL = $route.name ('Libro Diario'). Usa CRUD estándar:
	//   - 'create' -> crear asiento nuevo (botón "Nuevo Asiento" y flujo de alta)
	//   - 'update' -> editar asiento y sus detalles existentes
	//   - 'delete' -> eliminar / anular asiento y eliminar detalles
	//   - 'read'   -> ver (el ver-detalle no se gatea)
	// IMPORTANTE: verifica que $route.name sea la misma clave del mapa con
	//   window.permsDebug.map[this.$route.name]
	// Si no coincide (devuelve undefined), reemplaza el return de permsResource
	// por el uri real, p.ej.  return 'journal';
	function permsResource() {
		return (this.$route && this.$route.name) || '';
	}
	function canCreate() {
		return this.$can(this.permsResource, 'create');
	}
	function canUpdate() {
		return this.$can(this.permsResource, 'update');
	}
	function canDelete() {
		return this.$can(this.permsResource, 'delete');
	}
	// Escritura compartida entre alta y edición (agregar/guardar detalle).
	function canWrite() {
		return this.canCreate || this.canUpdate;
	}

	function beforeDestroy() {
		window.removeEventListener('keydown', this.onKeyPress);
	}

	async function created() {
		this.table.rows = [];
		window.addEventListener('keydown', this.onKeyPress);
		this.loadStates();
		this.table.rows = [];
		if (this.currentSubsidiary.id) {
			try {
				const { data: response } = await this.$http.get(`settings/${this.currentSubsidiary.customerId}/${this.currentSubsidiary.id}`);
				/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
				this.settings = response.additionalSettings;
				this.showNotification('La configuración de cuentas contables cargada.');
			} catch (err) {
				if (err.status === 500) {
					this.showGenericError();
				}
			} finally {
				this.loading = false;
			}
			this.setId(
				{ documentNumber: this.currentSubsidiary.documentNumber, id: this.currentSubsidiary.id },
				'subsidiaryId',
			);
		}
		this.accountingAccount.account = '4';
		const { records: dataPeriods } = await this.loadData('period-con');
		const periodos = Array.isArray(dataPeriods) ? dataPeriods : [];
		const periodoActivo = periodos
			.find(t => t.flagActive === 1 && t.transactionBlockingModule);
		this.transactionBlockingModule = periodoActivo
			? periodoActivo.transactionBlockingModule
			: null;
		this.table.rows = [];
		// this.periodLock = this.validatePeriodLock(value);
	}
	function removeItem(item) {
		this.seatRemove = item;
		const index = this.dataSelected.findIndex((e) => {
			const prop = e.accountingAccountId ? 'accountingAccountId' : 'id';
			return e[prop] === this.seatRemove[prop] && e.accountingAccountId
			=== this.seatRemove.accountingAccountId;
		});
		if (index > -1) {
			this.dataSelected.splice(index, 1);
		}
		this.debit = this.dataSelected.reduce((a, d) => {
			if (Number(d.amount) >= 0) {
				return a + Number(d.amount);
			}
			return a;
		}, 0);
		this.credit = this.dataSelected.reduce((a, d) => {
			if (Number(d.amount) < 0) {
				return Number(d.amount) + a;
			}
			return a;
		}, 0);
		this.balance = this.dataSelected.reduce((acc, i) => {
			const newAmount = Number(i.amount);
			return Number((acc + newAmount).toFixed(2));
		}, 0);
		if (this.settings.squareSeats) {
			if (this.balance === 0) {
				this.flagSquareSeats = false;
			} else {
				this.flagSquareSeats = true;
			}
		} else if (this.settings.squareSeats === false) {
			this.flagSquareSeats = false;
		}
	}
	function disabledFormSave() {
		this.balance = this.balance ? Number(this.balance.toFixed(2)) : 0;
		// Si el balance es cercano a 0, lo forzamos a 0
		const THRESHOLD = 1e-10;
		if (Math.abs(this.balance) < THRESHOLD) {
			this.balance = 0;
		}
		return !this.model.gloss || !this.model.date ||
			this.flagCostCenter || this.dataSelected.length <= 1 || this.balance !== 0;
	}
	function disabledCostCenter() {
		if (this.settings.autoCenterCost) {
			const cont = this.dataSelected.reduce((acum, item) => {
				let ac = acum;
				if (item.flagCostCenter) {
					ac += 1;
				}
				return ac;
			}, 0);
			return cont > 0;
		}
		return false;
	}

	function disabledFormClean() {
		const modelKeys = Object.keys(this.model);
		const modelDetailKeys = Object.keys(this.modelDetail);
		return modelKeys.every(mk => !this.model[mk]) && modelDetailKeys.every(mdk =>
			!this.modelDetail[mdk]);
	}

	function openDetail() {
		this.journalList = false;
	}

	function deleteJournal() {
		if (!this.canDelete) return;
		this.rowsIds = this.rowsSelected.map(row => row.id);
		this.cancelModal = true;
	}

	function mounted() {
		this.params.limit = 60;
	}

	function searchFilterJournal() {
		this.setId(
			{ documentNumber: this.currentSubsidiary.documentNumber, id: this.currentSubsidiary.id },
			'subsidiaryId',
		);
	}

	function addIcon() {
		if (!this.canCreate) return;
		this.action = {
			code: 'new-seat',
			title: 'Crear Asiento',
			value: true,
		};
	}

	function createAction() {
		if (!this.canCreate) return;
		const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
		if (reg.test(navigator.userAgent)) {
			this.action = {
				code: 'new-seat',
				title: 'Crear Asiento',
				value: true,
				width: 470,
			};
			if (this.moduleValue) {
				if (this.moduleValue.module) {
					this.model.moduleCode = this.moduleValue.module.code;
				}
			}
		} else {
			this.rowDetail = {};
			this.table.rows = this.table.rows.map((r) => {
				const newRow = { ...r };
				newRow.isVisited = false;
				return newRow;
			});
			this.codeJournal = null;
			this.rowSelected = {};
			this.dataSelected = [];
			this.dataSelectedOriginal = [];
			this.credit = null;
			this.debit = null;
			this.toDeclare = false;
			this.notDeclare = false;
			this.openDetailSeat = false;
			this.seccionHeader.currencySymbol = null;
			this.seccionHeader.should = null;
			this.seccionHeader.toHave = null;
			this.seccionHeader.balance = null;
			this.model = {
				code: '',
				currency: '',
				date: format(new Date(), 'YYYY-MM-DD'),
				gloss: '',
				moduleCode: '',
				ruc: '',
			};
			this.modelDetail = {
				accountingAccountId: null,
				account: null,
				concept: '',
				reference: '',
				costCenterId: null,
				amount: null,
			};
			if (this.moduleValue) {
				if (this.moduleValue.module) {
					this.model.moduleCode = this.moduleValue.module.code;
				}
			}
			this.showSeatForm = true;
			this.loadAccounts();
			setTimeout(() => {
				this.$nextTick(() => {
					const seatFocus = document.getElementById('focus-new-seat');
					if (seatFocus !== null) {
						seatFocus.click();
					}
				});
			}, 1000);
		}
	}

	function accountingName() {
		const account = this.accounts.find(acc => acc.account === this.model.account ||
			acc.code === this.model.account) || {};
		return account.name;
	}

	function actionsDisabled() {
		const disabled = this.rowsSelected.length === 0;
		const fewSelected = this.rowsSelected.length !== 1;
		const noSubsidiarySelected = lib.isEmpty(this.currentSubsidiary);
		return [
			{ code: 'delete-seat', disabled },
			{ code: 'new-seat-detail', disabled: fewSelected },
			{ code: 'new-seat', disabled: noSubsidiarySelected },
		];
	}

	function addRecord(record) {
		this.model.account = record.account;
		this.model.accountingAccount = { ...record };
		this.action.value = false;
		this.action.title = '';
		this.action.code = '';
	}

	function changePageRecords(page) {
		this.loadRecords(page);
	}

	function changeAmount(dataSelected) {
		this.debit = dataSelected.reduce((a, d) => a + d.amountDebe, 0);
		this.credit = dataSelected.reduce((a, d) => d.amountHaber + a, 0);
		this.balance = Number((this.debit - this.credit).toFixed(2));
		if (this.settings.squareSeats) {
			if (this.balance === 0) {
				this.flagSquareSeats = false;
			} else {
				this.flagSquareSeats = true;
			}
		} else if (this.settings.squareSeats === false) {
			this.flagSquareSeats = false;
		}
	}

	function closeModal() {
		this.action.value = false;
		this.action.title = '';
		this.action.code = '';
		this.model = {
			code: '',
			currency: '',
			date: null,
			gloss: '',
			moduleCode: '',
			ruc: '',
		};
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: null,
		};
		this.rowId = null;
		this.rowIdSeat = null;
		delete this.recordsParams.search;
	}

	function closeModelDelete() {
		this.action.value = false;
		this.action.title = '';
		this.action.code = '';
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: null,
		};
		this.rowId = null;
		this.rowIdSeat = null;
		delete this.recordsParams.search;
	}

	function closeDialog() {
		this.cancelModal = false;
	}

	async function confirmCancel() {
		if (!this.canDelete) return;
		this.loading = true;
		const payload = {
			moduleCode: this.moduleCode,
		};
		try {
			const response = this.moduleCode === 'COMPRA' ? await this.$http.patch(`accounting-seat-cancel/${this.rowId}?flagCancel=${this.flagCancel}`, payload) :
				await this.$http.patch(`accounting-seat-cancel/${this.rowId}`, payload);
			this.showNotification(`El asiento ${this.rowName} ha sido anulado correctamente.`);
			if (response.status === 200) {
				if (this.moduleCode === 'CAJA' || this.moduleCode === 'BANCO') {
					await this.$http.patch(`accounting-seats-cash-bank-cancel?subsidiaryId=${this.currentSubsidiary.id}`, { ids:	[this.rowId] });
				}
			}
			this.rowsIds = [this.rowId];
			this.onDeleteSeatInline();
			this.rowId = null;
			this.rowName = '';
			this.closeModal();
			this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id || null;
			this.params.page = 1;
		} catch (err) {
			console.log('err::: ', err);
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'COM_ACCOUNTING_SEATS_CANCELED') {
					this.showGenericError('El asiento ya se encuentra anulado.');
				}
			}
		} finally {
			this.loading = false;
		}
	}

	function filterBy(filters) {
		this.showSeatForm = false;
		this.dataSelected = [];
		this.rowSelected = {};
		this.balance = 0;
		this.credit = 0;
		this.debit = 0;
		if (filters.documentId) {
			this.params.documentId = filters.documentId;
		}
		if (filters.square) {
			this.params.square = filters.square;
		}
		if (filters.typeRegisterId) {
			this.moduleName = filters.typeRegisterId.name;
			this.params.typeRegisterId = filters.typeRegisterId.id;
		}
		/* if (filters.status === 1) {
			this.flagDisabledAddSeat = true;
		} else {
			this.flagDisabledAddSeat = false;
		} */
		this.closeModal();
		({ code: this.params.code, endDate: this.params.endDate,
			flagCostCenter: this.params.flagCostCenter, startDate: this.params.startDate,
			status: this.params.status } = filters);
		this.params.page = 1;
		this.loadData('accounting-seats');
	}

	function isActionCode(code) {
		return this.action.code === code;
	}

	async function loadCostCenters() {
		try {
			({ data: this.costCenters } = await this.$http.get(
				`cost-center/${this.params.subsidiaryId}/subsidiary`));
		} catch (err) {
			console.log('wwwwwerr::: ', err);
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	async function loadDetail(id) {
		try {
			({ data: this.dataSelected } = await this.$http.get(`accounting-seats/${id}`));
		} catch (err) {
			console.log('err::: ', err);
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'COM_ACCOUNTING_SEATS_NOT_FOUND') {
					this.showGenericError('El asiento no existe.');
				}
			}
		}
	}

	async function loadModules() {
		if (this.params.subsidiaryId) {
			({ data: this.modules } = await this.$http.get(
				`modules/${this.params.subsidiaryId}/subsidiary`));
			this.model.currency = this.isEcuador ? 'USD' : null;
			if (this.modules.length === 1 && !this.model.code) {
				this.moduleValue = this.modules[0];
				this.setModuleData(this.moduleValue);
			} else if (this.model.moduleCode) {
				this.moduleValue = this.modules.find(m => m.module.code === this.model.moduleCode);
				this.setModuleData(this.moduleValue);
			}
			const filterModules = this.modules.filter(items => items.name === 'CONTABILIDAD');
			this.modulesFilter = filterModules;
			this.setModuleData(this.modulesFilter[0]);
		} else if (!this.currentSubsidiary.id) {
			this.showNotification('Seleccione una empresa.', 'warning');
		}
	}

	async function loadRecords(page = 1) {
		this.currentPageRecords = page;
		this.recordsParams.page = page;
		try {
			const { data: records, headers } = await this.$http.get(
				`accounting-plan/${this.params.subsidiaryId}/subsidiary`,
				{ params: this.recordsParams });
			this.lastPage = Number(headers['x-last-page']);
			this.records = [...records];
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	async function loadStates() {
		({ data: this.states } = await this.$http.get('accounting-seats-states'));
	}

	function onClean() {
		this.params.code = null;
		this.params.endDate = null;
		this.params.flagCostCenter = null;
		this.params.startDate = null;
		this.params.status = null;
		this.params.subsidiaryId = null;
		this.params.typeRegisterId = null;
		this.loadData('accounting-seats');
	}

	function onClick(row) {
		this.loadCostCenters(row);
		this.selectDetail(row);
	}

	function onClickIcon({ action, row }) {
		this.moduleCode = row.typeRegister.code;
		if (this.moduleCode === 'CAJA' || this.moduleCode === 'BANCO') {
			const numberDocument = row.id;
			this.documentNumberUpdate = numberDocument;
		}
		this.rowId = row.id;
		this.rowName = row.gloss;
		if (action === 'new-seat') {
			if (!this.canUpdate) return;
			if (row.id) {
				this.rowSelected = { ...row };
				this.rowIdSeat = this.rowSelected.id;
				this.model.code = row.code;
				this.model.date = row.date;
				this.model.currency = row.currency;
				this.model.gloss = row.gloss;
				this.model.moduleCode = row.typeRegister.code;
				this.showHeadingBtn = true;
				this.action.code = action;
				this.action.title = 'Editar Asiento';
				this.action.width = 400;
				this.action.value = true;
			}
		} else if (action === 'see-detail') {
			// Funcion para ver el detalle del asiento
			this.seeDetail(row);
		} else if (action === 'cancel') {
			if (!this.canDelete) return;
			this.loading = false;
			this.action.code = action;
			this.action.title = 'Anular Asiento';
			this.action.width = 400;
			this.action.value = true;
		}
	}

	async function onDelete() {
		if (!this.canDelete) return;
		this.loading = true;
		try {
			const { data: response } = await this.$http.delete(`accounting-seat-details/${this.rowDetailId}`);
			this.showNotification('El detalle de asiento ha sido eliminado correctamente.');
			this.closeModal();
			this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
			this.loadData('accounting-seats');
			this.dataSelected = response.details;
			this.dataSelectedOriginal = response.details;
			this.debit = this.dataSelected.reduce((sum, item) => sum + item.amountDebe, 0);
			this.credit = Number(this.dataSelected.reduce((sum, item) => sum + item.amountHaber, 0) * -1);
			this.balance = response.totalDebe - response.totalHaber;
			this.seccionHeader.balance = Number((response.totalDebe - response.totalHaber).toFixed(2));
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	function onDeleteDetailSeat() {
		if (!this.canDelete) return;
		this.editDetailInline = true;
		this.dataSelected.splice(this.indexRowDetail, 1);
		this.action.value = false;
		this.indexRowDetail = null;
		this.isSquareAmounts = this.validateAmountActions(this.dataSelected);
		this.closeModelDelete();
		this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
	}

	async function onDeleteSeat() {
		if (!this.canDelete) return;
		this.loading = true;
		try {
			// Usamos map en lugar de forEach para obtener un array de promesas
			const promises = this.rowIdsModules.map(async (item) => {
				if (this.transactionBlockingModule
					&& this.transactionBlockingModule[codeModules[item.moduleName]]) {
					const formatDate = format(addHours(item.date, 5), 'YYYY-MM-DD');
					const codeBlokingModule = codeModules[item.moduleName];
					const isBlockItem = isBefore(formatDate, this.transactionBlockingModule[codeBlokingModule])
						|| isEqual(formatDate, this.transactionBlockingModule[codeBlokingModule]);
					if (isBlockItem) {
						this.itemsBlockedPeriod.push(item);
						return;
					}
				}
				const { id, moduleName, gloss, additionalInformation } = item;
				if (moduleName === 'CAJA' || moduleName === 'BANCO') {
					const numberDocument = gloss.match(/\d+/)[0];
					this.documentNumberUpdate = numberDocument;
				}
				const payload = {
					moduleCode: moduleName,
				};

				const params = {};
				if (additionalInformation && additionalInformation.flagFacWithDocStatus) {
					params.flagFacWithDocStatus = true;
				}

				const response = moduleName === 'COMPRA'
					? await this.$http.patch(`accounting-seat-cancel/${id}?flagCancel=${this.flagCancel}`, payload)
					: await this.$http.patch(`accounting-seat-cancel/${id}`, payload, { params });

				if (response.status === 200) {
					if (moduleName === 'CAJA' || moduleName === 'BANCO') {
						await this.$http.patch(`accounting-seats-cash-bank-cancel?subsidiaryId=${this.currentSubsidiary.id}`, { ids:	[id] });
					}
				}
			});
			// Esperar a que todas las promesas se resuelvan antes de continuar
			await Promise.all(promises);
		} catch (error) {
			console.log('error::: ', error);
			this.showGenericError();
		} finally {
			// Llamar a onDeleteSeatMultiple después de que todas las llamadas se completen
			this.onDeleteSeatMultiple();
		}
	}
	async function onDeleteSeatMultiple() {
		this.loading = true;
		const ids = {
			ids: this.rowsIds
				.filter(id =>
					!this.itemsBlockedPeriod.some(item => item.id === id)),
		};
		try {
			await this.$http.delete('accounting-seat', { data: ids });
			this.showNotification('La eliminación ha sido realizada correctamente.');
			this.closeModal();
			this.params.subsidiaryId = this.subsidiaryId || null;
			this.params.page = 1;
			this.loadData('accounting-seats');
			if (this.rowsIds.indexOf(this.rowSelected.id) > -1) {
				this.dataSelected = [];
				this.dataSelectedOriginal = [];
				this.rowsSelected = [];
				this.rowIdsModules = [];
				this.rowSelected = {};
			} else {
				this.seeDetail(this.rowSelected);
			}
		} catch (err) {
			console.log('erriiii::: ', err);
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
			this.closeDialog();
			this.onSelectedAll();
			if (this.itemsBlockedPeriod.length > 0) {
				this.showItemsBlock = true;
			}
		}
	}

	async function onDeleteSeatInline() {
		const ids = { ids: this.rowsIds };
		try {
			await this.$http.delete('accounting-seat', { data: ids });
			this.showNotification('La eliminación ha sido realizada correctamente.');
			this.closeModal();
			this.params.subsidiaryId = this.subsidiaryId || null;
			this.loadData('accounting-seats');
			if (this.rowsIds.indexOf(this.rowSelected.id) > -1) {
				this.dataSelected = [];
				this.dataSelectedOriginal = [];
				this.rowsSelected = [];
				this.rowIdsModules = [];
				this.rowSelected = {};
			} else {
				this.seeDetail(this.rowSelected);
			}
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
			this.closeDialog();
		}
	}

	async function onEditHeading() {
		if (!this.canUpdate) return;
		this.loading = true;
		const body = {
			code: this.model.code,
			date: this.model.date,
			gloss: this.model.gloss,
			moduleCode: this.model.moduleCode,
			ruc: this.rucSubsidiary || this.model.ruc,
		};
		try {
			await this.$http.patch(`accounting-seat/${this.rowId}`, body);
			this.showNotification('El asiento ha sido editado correctamente.');
			this.params.subsidiaryId = this.subsidiaryId || null;
			this.loadData('accounting-seats');
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'SUBSIDIARY_NOT_FOUND') {
					this.showGenericError('La sucursal referenciada al asiento no existe.');
				}
			}
		} finally {
			this.loading = false;
		}
	}

	function onInput(value) {
		this.model.account = value;
		this.recordsParams.search = value ? value.trim() : null;
	}

	function onInputDetail({ modelName, value }) {
		this.model[modelName] = value;
	}

	function onPage(page) {
		this.currentPage = page;
		this.params.page = page;
		this.loadData('accounting-seats');
	}

	async function onSave() {
		const allowed = this.rowId ? this.canUpdate : this.canCreate;
		if (!allowed) return;
		const method = this.rowId ? 'patch' : 'post';
		const url = this.rowId ? `accounting-seat/${this.rowId}` : 'accounting-seat';
		const action = this.rowId ? 'editar' : 'crear';
		const body = {
			date: format(this.model.date, 'YYYY-MM-DD'),
			gloss: this.model.gloss,
			moduleCode: this.model.moduleCode,
			code: this.model.code,
			currency: this.model.currency,
			ruc: this.currentSubsidiary.documentNumber,
		};
		try {
			await this.$http[method](url, body);
			this.showNotification(`El asiento ha sido ${action} correctamente.`);
			this.closeModal();
			this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
			this.loadData('accounting-seats');
			this.dataSelected = [];
			this.dataSelectedOriginal = [];
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'COM_MODULE_NOT_FOUND');
				this.showGenericError('Modulo no existe.');
			}
		}
	}

	async function onSaveDetail() {
		if (!this.canWrite) return;
		this.loading = true;
		const method = this.rowDetailId ? 'patch' : 'post';
		const url = this.rowDetailId ? `accounting-seat-details/${this.rowId}/${this.rowDetailId}` : `accounting-seat-details/${this.rowSelected.id}`;
		const action = this.rowDetailId ? 'editar' : 'crear';
		const body = {
			account: this.model.account,
			accountingAccountId: this.model.accountingAccountId,
			concept: this.model.concept,
			reference: this.model.reference,
			costCenterId: this.model.costCenterId,
			amount: this.model.amount,
		};
		try {
			await this.$http[method](url, body);
			this.showNotification(`El detalle de asiento ha sido ${action} correctamente.`);
			this.closeModal();
			this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
			await this.loadData('accounting-seats');
			this.seeDetail(this.rowSelected);
		} catch (err) {
			this.showGenericError();
		}
	}

	function onSearch(value) {
		this.currentPage = 1;
		this.params.page = this.currentPage;
		this.params.search = value ? value.trim() : null;
		this.loadData('accounting-seats');
	}

	function onSearchDetail(value) {
		const localSearch = value ? value.trim() : '';
		if (value.length) {
			this.dataSelected = [...this.dataSelectedOriginal];
			const rowsFilter = this.dataSelected.filter(item =>
				(item.account.toLowerCase().indexOf(localSearch.toLowerCase()) > -1));
			this.dataSelected = rowsFilter;
		} else {
			this.dataSelected = [...this.dataSelectedOriginal];
		}
	}

	function onSearchRecords(searchTable) {
		this.recordsParams.search = searchTable ? searchTable.trim() : null;
		this.loadRecords();
	}

	function onSelectedAll(checked) {
		this.checkAll = checked;
		this.table.rows = this.table.rows.map((tableRow) => {
			const newTableRow = { ...tableRow };
			newTableRow.isSelected = checked;
			return newTableRow;
		});
		this.rowsSelected = this.table.rows.filter(tableRow => tableRow.isSelected);
		this.dataSelected = [];
		this.dataSelectedOriginal = [];
	}

	function onTableOption(item) {
		this.action = { ...item };
		this.action.value = item.open;
		this.action.width = 371;
	}

	function onAction({ action, row, index }) {
		// Gateo por configuración: editar -> new-seat, eliminar -> delete-seat.
		if (action === 'delete') {
			if (!this.canDelete) return;
		} else if (!this.canWrite) {
			return;
		}
		this.indexRowDetail = index;
		const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
		try {
			if (reg.test(navigator.userAgent) || action === 'delete') {
				const seat = this.table.rows.find(r => r.id === row.accountingSeatId) || {};
				this.rowId = seat.id;
				this.rowName = seat.gloss;
				this.params.subsidiaryId = seat.subsidiaryId;
				this.rowDetailId = row.id;
				this.rowDetailName = row.accountingAccount.name;
				this.action.width = 400;
				this.action.code = action;
				if (action === 'new-detail-seat') {
					if (this.model) {
						this.onClick(row);
						this.action.title = 'Editar Detalle de Asiento';
						this.model.accountingAccountId = row.accountingAccountId;
					}
				} else if (action === 'delete') {
					this.action.title = 'Eliminar Detalle de Asiento';
				}
				this.action.value = true;
			} else {
				this.editDetailInline = true;
				this.openDetailSeat = false;
				this.modelDetail = { ...row };
				this.dataSelected = this.dataSelected.map((ds, indexD) => {
					const newDataSelected = { ...ds };
					newDataSelected.onEdit = indexD === this.indexRowDetail;
					return newDataSelected;
				});
				const focusDetailEdit = document.getElementById('focus-edit-inline');
				focusDetailEdit.click();
			}
		} catch (error) {
			this.showGenericError();
		}
	}

	function validButtonCostCenter() {
		const accounts = this.dataSelected.filter(item =>
			['4', '5', '6', '7', '8'].includes(item.account ? item.account.charAt(0) :
				item.accountingAccount.code.charAt(0)));
		if (this.settings.autoCenterCost) {
			if (accounts.length > 0) {
				const costCenterLength = accounts.filter(item => item.costCenterId === null).length;
				if (costCenterLength > 0) {
					this.showNotification('Hay cuentas con 4, 5, 6, 7, 8 sin centro de costo asignado');
				}
				return costCenterLength > 0;
			}
			return false;
		}
		return false;
	}

	function openSearcher() {
		this.action.title = 'Cuentas Contables';
		this.action.code = 'searcher';
		this.action.width = 550;
		this.action.value = true;
		this.recordsParams.search = this.model.accountingCode;
		this.loadRecords();
	}

	function rowIsSelected() {
		this.checkAll = this.table.rows.every(tableRow => tableRow.isSelected);
		this.rowsSelected = this.table.rows.filter(tableRow => tableRow.isSelected);
	}

	function currencySymbol(rowSelected) {
		return rowSelected.currency === 'PEN' ? 'S/.' : null;
	}

	function runAction({ code, name }) {
		if (code === 'delete-seat') {
			if (!this.canDelete) return;
			this.rowsIds = this.rowsSelected.map(row => row.id);
			this.rowIdsModules = this.rowsSelected.map(row => ({
				id: row.id,
				moduleName: row.typeRegister.code,
				gloss: row.gloss,
				additionalInformation: row.additionalInformation ? row.additionalInformation : {},
				date: row.date,
				code: row.code,
			}));
			this.cancelModal = true;
		} else {
			if (code === 'new-seat' && !this.canCreate) return;
			this.action.code = code;
			this.action.title = name;
			this.action.width = code === 'delete-seat' ? 300 : 400;
			this.action.value = true;
		}
	}

	async function subsidiaryChange(newSubsidiary) {
		if (newSubsidiary.id) {
			this.setId(
				{ documentNumber: newSubsidiary.documentNumber, id: newSubsidiary.id },
				'subsidiaryId',
			);
		} else {
			this.table.rows = [];
		}
	}

	function setId({ documentNumber, id }, modelName) {
		this.params[modelName] = id;
		if (modelName === 'subsidiaryId') {
			this.rucSubsidiary = documentNumber;
		}
		this.currentPage = 1;
		this.params.page = this.currentPage;
		this.dataSelected = [];
		this.dataSelectedOriginal = [];
		this.rowIdsModules = [];
		this.seccionHeader = {
			balance: null,
			currencySymbol: null,
			should: null,
			toHave: null,
		};
		this.credit = null;
		this.debit = null;
		this.cancelModal = false;
		this.headingSeat = false;
		this.notDeclare = false;
		this.toDeclare = false;
		this.loading = false;
		this.loadAccounts();
		this.loadModules();
		this.loadCostCenters();
		this.loadData('accounting-seats');
		const filas = (this.table && this.table.rows) || [];
		this.table.rows = filas.map((row) => {
			const newRow = { ...row };
			newRow.isVisited = false;
			return newRow;
		});
	}

	async function saveAccouting(id) {
		const body = {
			ids: [id],
		};
		try {
			await this.$http.patch('accounting-seat/confirm', body);
			this.showNotification('Los asientos fueron asignados correctamente');
		} catch (error) {
			this.showGenericError();
		}
	}

	function setHeadingData({ modelName, value }) {
		const condition = modelName === 'moduleId';
		this.model[modelName] = condition ? value.id : value;
		if (condition) {
			this.model.moduleCode = value.code;
		}
	}

	function setModel(type, row) {
		try {
			if (type === 'heading') {
				this.model.code = row.code;
				this.model.date = exactDate(row.date, 'YYYY-MM-DD');
				this.model.gloss = row.gloss;
				this.model.moduleId = row.moduleId || row.typeRegister.id;
				this.model.ruc = row.ruc;
				this.model.account = null;
				this.model.accountingAccount = {};
				this.model.amount = null;
				this.model.concept = null;
				this.model.costCenterId = null;
				this.model.reference = null;
				this.params.subsidiaryId = row.subsidiaryId;
			} else {
				this.model.account = row.account;
				this.model.accountingAccount = row.accountingAccount;
				this.model.amount = row.amount;
				this.model.concept = row.concept;
				this.model.costCenterId = row.costCenterId;
				this.model.reference = row.reference;
			}
		} catch (error) {
			this.showGenericError();
		}
	}

	function createDetailSeat() {
		if (!this.canWrite) return;
		this.action = {
			code: 'new-detail-seat',
			title: 'Nuevo detalle de asiento',
			value: true,
			open: true,
		};
	}

	function detailJournalList() {
		this.openDetailMobile = false;
	}

	function returnJournal() {
		this.openDetailMobile = true;
	}

	function clickFilter() {
		this.action.title = 'Filtros';
		this.action.code = 'filter-by';
		this.action.value = true;
	}
	function getSquareLabel(square) {
		if (square === 1) {
			return 'Cuadrado';
		} else if (square === undefined || square === null) {
			return 'Todos';
		}
		return 'No Cuadrado';
	}

	function getModuleLabel(module) {
		if (module) {
			return module;
		}
		return 'Todos';
	}

	function getStatusLabel(status) {
		if (status === 1) {
			return 'Mayorizados';
		} else if (status === undefined || status === null) {
			return 'Todos';
		}
		return 'Pendientes';
	}

	function clearFilter() {
		this.params.code = null;
		this.params.endDate = null;
		this.params.startDate = null;
		this.params.flagCostCenter = null;
		this.params.typeRegisterId = null;
		this.params.status = null;
		this.params.square = null;
		this.params.documentId = null;
		this.seccionHeader = {
			balance: null,
			currencySymbol: null,
			should: null,
			toHave: null,
		};
		this.headingSeat = false;
		this.loadData('accounting-seats');
	}

	function clearFilterMobile() {
		this.closeModal();
		this.clearFilter();
	}

	function mobileDetail(row) {
		this.detailJournalOpen = true;
		this.codeDetailJournal = row.code;
		this.dateDetailJournal = exactDate(row.date, 'YYYY-MM-DD');
		const index = this.table.rows.findIndex(t => t.id === row.id);
		if (index > -1) {
			this.dataSelected = this.table.rows[index].details ?
				this.table.rows[index].details.map((detail) => {
					const newDetail = { ...detail };
					newDetail.accountingAccount = detail.accountingAccount || {};
					newDetail.amount = detail.amount || 0;
					newDetail.accountingAccount = detail.accountingAccount || {};
					newDetail.costCenter = detail.costCenter || {};
					return newDetail;
				}) : [];
			this.dataSelectedOriginal = [...this.dataSelected];
			this.rowIdSeat = this.table.rows[index].id;
			this.credit = this.table.rows[index].totalHaber * -1;
			this.debit = this.table.rows[index].totalDebe;
			this.seccionHeader.currencySymbol = this.currencySymbol(this.table.rows[index]);
			this.seccionHeader.should = this.table.rows[index].totalDebe;
			this.seccionHeader.toHave = this.table.rows[index].totalHaber * -1;
			this.seccionHeader.balance =
				Number((this.table.rows[index].totalDebe - this.table.rows[index].totalHaber).toFixed(2));
			if (this.credit === this.debit) {
				this.toDeclare = true;
				this.notDeclare = false;
			}
			if (this.credit !== this.debit) {
				this.notDeclare = false;
			}
			if (this.seccionHeader.balance > 0 || this.balance > 0) {
				this.notDeclare = true;
			}
			this.openMobile = true;
		}
	}

	function closeMobile() {
		this.detailJournalOpen = false;
		this.openMobile = false;
	}

	function selectDetail(row) {
		try {
			this.rowDetail = { ...row };
			this.dataSelected = this.dataSelected.map((d) => {
				const newRow = { ...d };
				newRow.isSelected = d.id === row.id;
				return newRow;
			});
			this.dataSelectedOriginal = this.dataSelectedOriginal.map((d) => {
				const newRow = { ...d };
				newRow.isSelected = d.id === row.id;
				return newRow;
			});
		} catch (error) {
			this.showGenericError();
		}
	}

	function seeDetail(row) {
		// Este row es la data del asiento.
		this.rowDetail = {};
		this.showSeatForm = false;
		this.loadAccounts();
		this.table.rows = this.table.rows.map((r) => {
			const newRow = { ...r };
			newRow.isVisited = r.id === row.id;
			return newRow;
		});
		this.codeJournal = row.code;
		this.rowSelected = { ...row }; // Asigna da la data del asiento a esta variable
		this.dataSelected = row.details ? row.details.map((detail) => {
			const newDetail = { ...detail };
			newDetail.accountingAccount = detail.accountingAccount || {};
			newDetail.amount = detail.amount || 0;
			newDetail.accountingAccount = detail.accountingAccount || {};
			newDetail.costCenter = detail.costCenter || {};
			return newDetail;
		}) : [];
		this.dataSelectedOriginal = [...this.dataSelected];
		this.credit = row.totalHaber * -1;
		this.debit = row.totalDebe;
		this.balance = row.totalDebe - row.totalHaber;
		this.toDeclare = Math.abs(this.credit) === Math.abs(this.debit);
		this.notDeclare = Math.abs(this.credit) !== Math.abs(this.debit);
		this.seccionHeader.currencySymbol = this.currencySymbol(row);
		this.seccionHeader.should = row.totalDebe;
		this.seccionHeader.toHave = row.totalHaber * -1;
		this.seccionHeader.balance = Number((row.totalDebe - row.totalHaber).toFixed(2));
		try {
			this.loadModules(row);
			this.setModel('heading', row);
		} catch (error) {
			console.log('errrrrror::: ', error);
			this.showGenericError();
		}
	}

	async function loadAccounts() {
		this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
		const params = {
			status: 1,
		};
		try {
			({ data: this.accounts } = await this.$http.get(
				`accounting-plan/${this.params.subsidiaryId}/subsidiary`, { params }));
			this.accounts = this.accounts.map((acc) => {
				const newAcc = { ...acc };
				newAcc.disabled = acc.stat === 1;
				return newAcc;
			});
		} catch (error) {
			console.log('errooooooyyyyor::: ', error);
		}
		// if (this.showSeatForm) {
		// 	this.accounts = this.accounts.filter(a => a.auxCont === 0);
		// }
	}

	function setCostCenter(value) {
		this.costCenter = { ...value };
		this.modelDetail.costCenterId = value.id;
	}

	function setData(value) {
		if (this.settings && this.settings.stat && value.stat === 1) {
			this.accountingAccount = null;
			this.modelDetail.account = null;
			this.modelDetail.accountingAccountId = null;
			this.modelDetail.codeAccounting = null;
			this.showNotification('La cuenta no se puede seleccionar', 'warning');
		} else {
			this.accountingAccount = { ...value };
			this.modelDetail.account = value.code;
			this.modelDetail.accountingAccountId = value.id;
			this.modelDetail.codeAccounting = value.account;
		}
		// this.accountingAccount = { ...value };
		// this.modelDetail.account = value.code;
		// this.modelDetail.accountingAccountId = value.id;
		// this.modelDetail.codeAccounting = value.account;
	}

	function changeDate(value) {
		this.model.date = value;
		this.model.moduleCode = 'Contabilidad';
		this.onEditHeading();
	}

	function disabledBtnAdd() {
		return (
			!this.modelDetail.accountingAccountId || !this.modelDetail.account ||
			!this.modelDetail.concept || !this.modelDetail.reference || !this.modelDetail.amount
			// (this.accountingAccount.account.startsWith('4')
			// || this.accountingAccount.account.startsWith('5'))
			// && (this.modelDetail.costCenterId === null)
		);
	}

	function setModelData({ model, value }) {
		if (model === 'date' || model === 'gloss') {
			this.model[model] = value;
		} else {
			this.modelDetail[model] = value;
		}
		this.balance = this.dataSelected.reduce((acc, item) => {
			const newAmount = Number(item.amount);
			return Number((acc + newAmount).toFixed(2));
		}, 0);
		if (this.settings.squareSeats) {
			if (this.balance === 0) {
				this.flagSquareSeats = false;
			} else {
				this.flagSquareSeats = true;
			}
		} else if (this.settings.squareSeats === false) {
			this.flagSquareSeats = false;
		}
	}

	function setModuleData(moduleData) {
		console.log('moduleData::: ', moduleData);
		this.module = { ...moduleData };
		this.model.moduleCode = this.module.module.code;
	}

	async function onSaveMultiple(done) {
		if (!this.canCreate) return;
		const body = {
			accountingAccountDetail: this.dataSelected.map(detail => ({
				accountingAccountId: detail.accountingAccountId,
				account: detail.account,
				amount: detail.amount,
				concept: detail.concept,
				costCenterId: detail.costCenterId,
				reference: detail.reference,
				codeAccounting: detail.accountingAccount.account || '',
			})),
			currency: this.isEcuador ? 'USD' : 'PEN',
			date: format(this.model.date, 'YYYY-MM-DD'),
			gloss: this.model.gloss,
			moduleCode: this.model.moduleCode,
			ruc: this.rucSubsidiary,
		};
		try {
			const res = await this.$http.post(
				'accounting-seats/multiple_details', body);
			const bodyConfirm = {
				ids: [res.data.id],
			};
			await this.$http.patch(
				'accounting-seat/confirm',
				bodyConfirm,
			);
			this.showNotification('El asiento y los detalles han sido creados correctamente.');
			await this.loadData('accounting-seats');
			this.seeDetail(this.table.rows[0]);
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			if (typeof done === 'function') {
				done();
			}
		}
	}

	async function saveDetailSeat() {
		if (!this.canWrite) return;
		this.dataSelected.push({
			...this.modelDetail,
			accountingAccount: this.accountingAccount,
			costCenter: this.costCenter,
		});
		const body = {
			accountingAccountId: this.modelDetail.accountingAccountId,
			account: this.modelDetail.account,
			amount: this.modelDetail.amount,
			concept: this.modelDetail.concept,
			reference: this.modelDetail.reference,
			costCenterId: this.modelDetail.costCenterId,
		};
		try {
			const { data: response } = await this.$http.post(`/accounting-seat-details/${this.rowSelected.id}`, body);
			this.showNotification('Nuevo Detalle de Asiento guardo correctamente.');
			this.modelDetail = {
				accountingAccountId: null,
				account: null,
				concept: '',
				reference: '',
				costCenterId: null,
				amount: null,
			};
			await this.loadData('accounting-seats');
			this.costCenter = {};
			this.accountingAccount = {};
			this.dataSelected = response.details;
			this.debit = this.dataSelected.reduce((sum, item) => sum + item.amountDebe, 0);
			this.credit = Number(this.dataSelected.reduce((sum, item) => sum + item.amountHaber, 0) * -1);
			this.balance = response.totalDebe - response.totalHaber;
			this.seccionHeader.balance = response.totalDebe - response.totalHaber;
			this.openDetailSeat = false;
		} catch (error) {
			this.showGenericError();
		} finally {
			await this.loadData('accounting-seats');
		}
	}

	async function saveNewDetailSeat() {
		if (!this.canWrite) return;
		const amount = Number(this.modelDetail.amount);
		const type = amount > 0 ? 'Debe' : 'Haber';
		this.modelDetail.type = amount > 0 ? 1 : 2;
		this.modelDetail.status = 1;
		this.modelDetail[`amount${type}`] = type === 'Debe' ? amount : (amount * -1);
		const otherType = type === 'Debe' ? 'Haber' : 'Debe';
		this.modelDetail[`amount${otherType}`] = 0;
		this.dataSelected.push({
			...this.modelDetail,
			accountingAccount: this.accountingAccount,
			costCenter: this.costCenter,
		});
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: null,
			reference: null,
			costCenterId: null,
			amount: null,
		};
		this.costCenter = {};
		this.accountingAccount = {};
		this.openDetailSeat = false;
		this.isSquareAmounts = this.validateAmountActions(this.dataSelected);
	}

	function addDetail() {
		if (!this.canWrite) return;
		// Agrega nuevo asiento contable
		this.modelDetail.type = Number(this.modelDetail.amount) > 0 ? 1 : 2;
		const type = this.modelDetail.type === 1 ? 'Debe' : 'Haber';
		const newValue = this.modelDetail.type === 1 ? Number(this.modelDetail.amount) :
			(Number(this.modelDetail.amount) * -1);
		this.modelDetail[`amount${type}`] = newValue;
		if (type === 'Debe') {
			this.modelDetail.amountHaber = 0;
		} else {
			this.modelDetail.amountDebe = 0;
		}
		this.dataSelected.push({
			...this.modelDetail,
			accountingAccount: this.accountingAccount,
			flagCostCenter: this.accountingAccount.account.split('.')[0] === '4' || this.accountingAccount.account.split('.')[0] === '5',
			costCenter: this.costCenter,
		});
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: null,
			reference: null,
			costCenterId: null,
			amount: null,
		};
		this.costCenter = {};
		this.accountingAccount = {};
		this.accountingAccount.account = '4';
		this.debit = this.dataSelected.reduce((a, d) => {
			if (Number(d.amount) >= 0) {
				return a + Number(d.amount);
			}
			return a;
		}, 0);
		this.credit = this.dataSelected.reduce((a, d) => {
			if (Number(d.amount) < 0) {
				return Number(d.amount) + a;
			}
			return a;
		}, 0);
		this.balance = this.dataSelected.reduce((acc, item) => {
			const newAmount = Number(item.amount);
			return Number((acc + newAmount).toFixed(2));
		}, 0);
		if (this.settings.squareSeats) {
			if (this.balance === 0) {
				this.flagSquareSeats = false;
			} else {
				this.flagSquareSeats = true;
			}
		} else if (this.settings.squareSeats === false) {
			this.flagSquareSeats = false;
		}
		this.$nextTick(() => {
			const setFocus = document.getElementById('focus-added');
			if (setFocus !== null) {
				setFocus.click();
			}
		});
		// const setFocus = document.getElementById('focus-added');
		// setFocus.click();
	}

	function typeDetail() {
		return this.modelDetail.amount < 0 ? 'HABER' : 'DEBE';
	}

	function cleanAll() {
		this.model = {
			code: null,
			currency: null,
			date: format(new Date(), 'YYYY-MM-DD'),
			gloss: null,
			moduleCode: null,
			ruc: null,
		};
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: null,
			reference: null,
			costCenterId: null,
			amount: null,
		};
		this.debit = 0;
		this.credit = 0;
		this.balance = 0;
		this.seccionHeader.balance = 0;
		this.dataSelected = [];
		this.rowSelected = {};
	}

	function cancelEditionDetail() {
		this.model = {
			code: null,
			currency: null,
			date: null,
			gloss: null,
			moduleCode: null,
			ruc: null,
		};
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: null,
		};
		this.debit = 0;
		this.credit = 0;
		this.balance = 0;
		this.dataSelected = [];
		this.rowSelected = {};
		this.editDetailInline = false;
	}

	function onKeyPress(event) {
		const ctrlKeyPressed = event.ctrlKey;
		const altKeyPressed = event.altKey;
		const lKeyPressed = event.code === 'KeyL';
		const eKeyPressed = event.code === 'KeyE';
		const keyAccess = ctrlKeyPressed && altKeyPressed && lKeyPressed;
		const keyAccessEdit = ctrlKeyPressed && altKeyPressed && eKeyPressed;
		if (keyAccess) {
			this.createAction();
		}
		if (keyAccessEdit) {
			this.onAction({ row: this.dataSelected[0] });
		}
		if (event.code === 'Escape') {
			this.editDetailInline = false;
			this.model = {
				code: '',
				currency: '',
				date: null,
				gloss: '',
				moduleCode: '',
				ruc: '',
			};
			this.modelDetail = {
				accountingAccountId: null,
				account: null,
				concept: '',
				reference: '',
				costCenterId: null,
				amount: null,
			};
			this.dataSelected = this.dataSelected.map((ds) => {
				const newDataSelected = { ...ds };
				newDataSelected.onEdit = false;
				return newDataSelected;
			});
		}
	}

	function setDataDetail({ model, value, row, index }) {
		if (model === 'reference') {
			this.dataSelected[index].reference = value;
		}
		if (model === 'concept') {
			this.dataSelected[index].concept = value;
		}
		if (model === 'amount') {
			this.$set(this.dataSelected[index], 'amount', value);
			this.$set(this.dataSelected[index], 'type', Number(value) > 0 ? 1 : 2);
			const type = row.type === 1 ? 'Debe' : 'Haber';
			const newValue = row.type === 1 ? Number(value) : (Number(value) * -1);
			this.$set(this.dataSelected[index], `amount${type}`, newValue);
			if (type === 'Debe') {
				this.$set(this.dataSelected[index], 'amountHaber', 0);
			} else {
				this.$set(this.dataSelected[index], 'amountDebe', 0);
			}
			const newData = [...this.dataSelected];
			this.changeAmount(newData);
		}
		if (model === 'accountingAccount') {
			if (this.settings && this.settings.stat && value.stat === 1) {
				const findAccount = this.accounts
					.find(acc => acc.id === this.dataSelected[index].accountingAccountId);
				this.modelDetail.account = findAccount.code;
				this.modelDetail.accountingAccountId = findAccount.id;
				this.dataSelected[index].accountingAccount = findAccount;
				this.dataSelected[index].accountingAccountId = findAccount.id;
				this.dataSelected[index].account = findAccount.code;
				this.showNotification('La cuenta no se puede seleccionar', 'warning');
			} else {
				this.modelDetail.account = value.code;
				this.modelDetail.accountingAccountId = value.id;
				this.dataSelected[index].accountingAccount = value;
				this.dataSelected[index].accountingAccountId = value.id;
				this.dataSelected[index].account = value.code;
			}
			// this.modelDetail.account = value.code;
			// this.modelDetail.accountingAccountId = value.id;
			// this.dataSelected[index].accountingAccount = value;
			// this.dataSelected[index].accountingAccountId = value.id;
			// this.dataSelected[index].account = value.code;
		}
		if (model === 'costCenter') {
			this.modelDetail.costCenterId = value ? value.id : null;
			this.dataSelected[index].costCenter = value;
			this.dataSelected[index].costCenterId = value ? value.id : null;
			this.dataSelected[index].flagCostCenter = false;
			this.flagValidCostCenter = false;
		}
		this.isSquareAmounts = this.validateAmountActions(this.dataSelected);
	}

	async function inlineEditDetail() {
		if (!this.canUpdate) return;
		try {
			const body = {
				account: this.modelDetail.account,
				accountingAccountId: this.modelDetail.accountingAccountId,
				amount: this.modelDetail.amount,
				concept: this.modelDetail.concept,
				costCenterId: this.modelDetail.costCenterId,
				reference: this.modelDetail.reference,
			};
			try {
				const { data: response } = await this.$http.patch(
					`accounting-seat-details/${this.modelDetail.accountingSeatId}/${this.modelDetail.id}`,
					body,
				);
				this.dataSelected = response.details;
				this.debit = this.dataSelected.reduce((sum, item) => sum + item.amountDebe, 0);
				this.credit = (this.dataSelected.reduce((sum, item) => sum + item.amountHaber, 0) * -1);
				this.balance = response.totalDebe - response.totalHaber;
				this.flagValidCostCenter = false;
				this.seccionHeader.should = this.debit;
				this.seccionHeader.toHave = this.credit;
				this.seccionHeader.balance =
				Number(this.seccionHeader.should - (this.seccionHeader.toHave * -1));
				this.showNotification('Detalle de asiento editado correctamente');
				this.editDetailInline = false;
				this.model = {
					code: '',
					currency: '',
					date: null,
					gloss: '',
					moduleCode: '',
					ruc: '',
				};
				this.modelDetail = {
					accountingAccountId: null,
					account: null,
					concept: '',
					reference: '',
					costCenterId: null,
					amount: null,
				};
			} catch (err) {
				if (err.status === 500) {
					this.showGenericError();
				}
			}
		} catch (error) {
			this.showGenericError();
		}
	}

	function addDetailSeat() {
		if (!this.canWrite) return;
		this.clearModels();
		this.openDetailSeat = !this.openDetailSeat;
		this.editDetailInline = true;
		this.dataSelected = this.dataSelected.map((ds) => {
			const newDataSelected = { ...ds };
			newDataSelected.onEdit = false;
			return newDataSelected;
		});
		this.modelDetail.concept = this.dataSelected.length > 0 ? this.dataSelected[0].concept : null;
		this.modelDetail.reference = this.dataSelected.length > 0 ? this.dataSelected[0].reference : null;
	}

	async function saveAllDetailsEdits() {
		if (!this.canWrite) return;
		this.loading = true;
		const body = this.formatData(this.dataSelected);
		try {
			const { data: response } = await this.$http.patch(`accounting-seat-update-daily/${this.rowSelected.id}`, body);
			this.rowSelected = response;
			this.dataSelected = response.details;
			this.dataSelected = this.dataSelected.map((ds) => {
				const newDs = { ...ds };
				newDs.accountingAccount = this.accounts.find(a => a.id === ds.accountingAccountId);
				newDs.costCenterId = ds.costCenterId ? ds.costCenterId : null;
				newDs.amount = ds.amountDebe > 0 ? ds.amountDebe : (ds.amountHaber * -1);
				return newDs;
			});
			this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
			this.debit = this.dataSelected.reduce((sum, item) => sum + item.amountDebe, 0);
			this.credit = (this.dataSelected.reduce((sum, item) => sum + item.amountHaber, 0) * -1);
			this.balance = response.totalDebe - response.totalHaber;
			this.seccionHeader.balance = response.totalDebe - response.totalHaber;
			this.showNotification('Detalles actualizados Correctamente');
			await this.loadData('accounting-seats');
			this.clearModels();
		} catch (error) {
			this.showGenericError();
		} finally {
			this.editDetailInline = false;
			this.openDetailSeat = false;
			this.loading = false;
		}
	}

	function formatData(value) {
		const totalDebe = value.reduce((sum, item) => sum + item.amountDebe, 0);
		const totalHaber = value.reduce((sum, item) => sum + item.amountHaber, 0);
		const details = value.map((d) => {
			const newD = {};
			newD.id = d.id ? d.id : null;
			newD.type = d.type;
			newD.account = d.account || null;
			newD.concept = d.concept;
			newD.reference = d.reference;
			newD.amountDebe = Number(d.amountDebe);
			newD.amountHaber = Number(d.amountHaber);
			newD.costCenterId = d.costCenterId ? d.costCenterId : null;
			newD.accountingAccountId = d.accountingAccountId;
			newD.codeAccounting = d.codeAccounting;
			return newD;
		});
		const newData = {
			totalDebe,
			totalHaber,
			details,
		};
		if (this.rowSelected.clone === 1) {
			newData.clone = 2;
		}
		return newData;
	}

	function validateAmountActions(array) {
		this.debit = Number(array.reduce((sum, item) => sum + item.amountDebe, 0).toFixed(2));
		this.credit = Number((array.reduce((sum, item) => sum + item.amountHaber, 0) * -1).toFixed(2));
		const credit = (this.credit * -1);
		this.balance = this.debit - credit;
		const THRESHOLD = 1e-10;
		if (Math.abs(this.balance) < THRESHOLD) {
			this.balance = 0;
		}
		this.seccionHeader.balance = this.debit - credit;
		return this.debit > credit || this.debit < credit;
	}

	function clearModels() {
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			codeAccounting: null,
			costCenterId: null,
			amount: null,
		};
	}
	function validInsertCostCenter() {
		let valid = false;
		if (this.settings.autoCenterCost) {
			if (this.modelDetail.account) {
				const firstDigit = this.modelDetail.account.charAt(0);
				if ((Number(firstDigit) >= 4 && Number(firstDigit <= 8)) && !this.modelDetail.costCenterId) {
					valid = true;
				}
			}
			return valid;
		}
		return valid;
	}
function buildSeatPreview(row) {
		const details = (row.details || []).map((detalle) => {
			const nuevo = { ...detalle };
			nuevo.id = null;
			nuevo.accountingAccount = detalle.accountingAccount || {};
			nuevo.costCenter = detalle.costCenter || {};
			nuevo.amount = detalle.amountDebe > 0
				? detalle.amountDebe
				: (detalle.amountHaber * -1);
			return nuevo;
		});
		return { ...row, details };
	}

	async function cloneSeat(row) {
		if (!this.canCreate) return;
		if (row.clone === 1) {
			this.showNotification('Asiento Clonado Pendiente para Revisión', 'warning');
			return;
		}
		this.seatToCloneId = row.id;
		this.dataSeatClone = this.buildSeatPreview(row);
		this.loadModules(row);
		this.showPreviewClone = true;
	}

	async function confirmClone(body) {
		if (!this.canCreate) return;
		this.savingClone = true;
		const params = { subsidiaryId: this.currentSubsidiary.id };
		try {
			const { data: nuevoAsiento } = await this.$http.post(
				`/accounting-seat-clone/${this.seatToCloneId}`, null, { params });
			await this.$http.patch(`accounting-seat-update-daily/${nuevoAsiento.id}`, body);
			this.showNotification('Asiento clonado y guardado correctamente');
			this.showPreviewClone = false;
			this.dataSeatClone = {};
			this.seatToCloneId = null;
			await this.loadData('accounting-seats');
		} catch (error) {
			this.showGenericError();
		} finally {
			this.savingClone = false;
		}
	}
	async function closePreview() {
		this.showPreviewClone = false;
		await this.loadData('accounting-seats');
		this.dataSeatClone = {};
		this.openDetailSeat = false;
	}
	async function printSeat(row) {
		try {
			const payload = {
				code: 'report-seat',
			};
			const params = {
				subsidiaryId: row.subsidiaryId,
			};
			const { data: response } = await this.$http.post(`/accounting-seats/${row.id}/print`, payload, { params });
			const contentType = 'text/html';
			if (contentType !== 'text/html') {
				this.showGenericError('El archivo no es HTML');
				return;
			}
			const iframe = document.createElement('iframe');
			iframe.style.display = 'none';
			document.body.appendChild(iframe);
			iframe.contentDocument.open();
			iframe.contentDocument.write(response);
			iframe.contentDocument.close();
			await new Promise((resolve) => {
				iframe.onload = resolve;
			});
			iframe.contentWindow.print();
			this.showNotification('Archivo PDF descargado exitosamente.');
		} catch (error) {
			this.showGenericError();
		}
	}

	function importExcel() {
		if (!this.canCreate) return;
		this.$refs.fileInput.click();
	}

	function readingBookExcel(buffer) {
		const dataFile = new Uint8Array(buffer);
		const workbook = XLSX.read(dataFile, { type: 'array' });
		const sheetName = workbook.SheetNames[0];
		const sheet = workbook.Sheets[sheetName];
		const filas = XLSX.utils.sheet_to_json(sheet, { header: 1 })
			.filter(row => Object.values(row)
				.some(cell => cell !== null && cell !== ''));
		filas.shift();
		return filas;
	}

	function proccessRowExcel(jsonData) {
		return jsonData.map((row) => {
			const obj = {};
			const amount = Number(row[5]);
			const type = amount > 0 ? 'Debe' : 'Haber';
			obj.amount = amount;
			obj.type = amount > 0 ? 1 : 2;
			obj[`amount${type}`] = type === 'Debe' ? amount : (amount * -1);
			const otherType = type === 'Debe' ? 'Haber' : 'Debe';
			obj[`amount${otherType}`] = 0;
			obj.reference = row[2];
			obj.concept = row[3];
			const objAccount = this.createNewObjAccount(row[0]);
			const objCostCenter = this.createNewObjCostCenter(row[6], row[0]);
			return { ...obj, ...objAccount, ...objCostCenter };
		});
	}

	function totalSelecion() {
		this.debit = this.dataSelected.reduce((a, d) => {
			if (Number(d.amount) >= 0) {
				return a + Number(d.amount);
			}
			return a;
		}, 0);
		this.credit = this.dataSelected.reduce((a, d) => {
			if (Number(d.amount) < 0) {
				return Number(d.amount) + a;
			}
			return a;
		}, 0);
		this.balance = this.dataSelected.reduce((acc, item) => {
			const newAmount = Number(item.amount);
			return Number((acc + newAmount).toFixed(2));
		}, 0);
	}

	function handleFileUpload(event) {
		const file = event.target.files[0];
		this.$refs.fileInput.value = null;
		if (!file) {
			return;
		}
		this.loadingData = true;
		const reader = new FileReader();
		reader.onload = (e) => {
			try {
				const jsonData = this.readingBookExcel(e.target.result);
				const newData = this.proccessRowExcel(jsonData);
				const faltantes = newData
					.map((fila, index) => (fila.account === null ? index : -1))
					.filter(index => index > -1);
				this.valuesNotFound = faltantes.map(index => jsonData[index][0]);
				if (faltantes.length > 0) {
					this.showDialog = true;
					this.dataSelected = newData.filter(nD => nD.account !== null);
				} else {
					this.dataSelected = newData;
				}
				this.totalSelecion();
			} catch (error) {
				console.error('No se pudo leer el archivo de Excel', error);
			} finally {
				this.disguiseWait();
			}
		};
		reader.onerror = () => {
			this.disguiseWait();
		};
		reader.readAsArrayBuffer(file);
	}
	function disguiseWait() {
		clearTimeout(this.timerCargando);
		this.timerCargando = setTimeout(() => {
			this.loadingData = false;
		}, 3000);
	}

	function createNewObjAccount(value) {
		console.log('value::: ', value);
		console.log(' this.accounts::: ', this.accounts);
		console.log('this.accounts.find(a => a.account === value::: ', this.accounts.find(a => a.account === '6.03'));
		const findAccount = this.accounts.find(a => a.account === `${value}` || a.account === `${value}.`);
		console.log('findAccount::: ', findAccount);
		const objAccount = {
			accountingAccountId: null,
			account: null,
			accountingAccount: {},
		};
		if (findAccount) {
			objAccount.accountingAccountId = findAccount.id;
			objAccount.account = findAccount.code;
			objAccount.accountingAccount = findAccount;
		}
		return objAccount;
	}

	function createNewObjCostCenter(value, accountCode) {
		const objCostCenter = {
			costCenterId: null,
			costCenter: {},
			flagCostCenter: false,
		};
		if (value) {
			const findCostCenter = this.costCenters.find(c => c.name === value);
			if (findCostCenter) {
				objCostCenter.costCenterId = findCostCenter.id;
				objCostCenter.costCenter = findCostCenter;
				objCostCenter.flagCostCenter = accountCode.split('.')[0] === '4'
					|| accountCode.split('.')[0] === '5'
					|| accountCode.split('.')[0] === '6'
					|| accountCode.split('.')[0] === '7'
					|| accountCode.split('.')[0] === '8';
			}
		}
		return objCostCenter;
	}

	function closeAlert() {
		this.showDialog = false;
		this.valuesNotFound = null;
	}

	function onDownloadFormat() {
		const fileUrl = '/static/documents/formato-exportacion.xlsx';
		const fileName = 'formato-exportacion.xlsx';
		fetch(fileUrl)
			.then((response) => {
				if (!response.ok) {
					throw new Error('Error al descargar el archivo.');
				}
				return response.blob();
			})
			.then((blob) => {
				saveAs(blob, fileName);
			})
			.catch((error) => {
				this.showGenericError('Error al descargar el archivo:', error);
			});
	}

	function detailDocument(row) {
		this.detailsRegister = { ...row.register };
		this.showDetails = true;
	}

	function closeDetailDocument() {
		this.showDetails = false;
		this.detailsRegister = null;
	}

	function getLabelRegister() {
		/* eslint-disable no-nested-ternary */
		const newData = {
			value: null,
			label: '',
		};
		if (this.detailsRegister && this.detailsRegister.data) {
			if (this.detailsRegister.data.customerId) {
				const { customer } = this.detailsRegister.data;
				newData.label = 'Cliente';
				newData.value = customer.rzSocial
					? customer.rzSocial
					: customer.typePerson && customer.typePerson.fullName
						? customer.typePerson.fullName : '';
			} else if (this.detailsRegister.data.supplierId) {
				const { supplier } = this.detailsRegister.data;
				newData.label = 'Proveedor';
				newData.value = supplier.name
					? supplier.name : '';
			}
		}
		/* eslint-enable no-nested-ternary */
		return newData;
	}

	function closItemsBlock() {
		this.itemsBlockedPeriod = [];
		this.showItemsBlock = false;
	}

	function data() {
		return {
			accountingAccount: {},
			accounts: [],
			action: {
				code: '',
				title: '',
				value: false,
			},
			balance: 0,
			seatToCloneId: null,
			savingClone: false,
			flagDisabledAddSeat: false,
			flagEditInline: false,
			cancelModal: false,
			checkAll: false,
			moduleCode: null,
			codeAccountant: '',
			codeDetailJournal: null,
			codeJournal: null,
			columns: [
				{ id: 1, name: 'Cód. cta. contable', value: 'code', checked: true, visible: true },
				{ id: 3, name: 'Nombre cta. contable', value: 'name', checked: true, visible: true },
				{ id: 4, name: 'Acciones', checked: true, visible: true, flagVisible: true },
			],
			costCenters: [],
			costCenter: {},
			seatRemove: {},
			settings: {},
			credit: 0,
			currentPage: 1,
			documentNumberUpdate: null,
			currentPageRecords: 1,
			dataSelected: [],
			dataSelectedOriginal: [],
			dateDetailJournal: null,
			debit: 0,
			detailJournalOpen: false,
			editDetailInline: false,
			headingSeat: false,
			journalList: true,
			lastPage: 0,
			loading: false,
			loadingFilter: false,
			model: {
				code: '',
				currency: '',
				date: null,
				gloss: '',
				moduleCode: '',
				ruc: '',
			},
			modelDetail: {
				accountingAccountId: null,
				account: null,
				concept: null,
				reference: null,
				costCenterId: null,
				amount: null,
			},
			module: {},
			modules: [],
			moduleName: null,
			moduleValue: {},
			notDeclare: false,
			openDetailSeat: false,
			openMobile: false,
			records: [],
			recordsParams: {
				limit: 60,
				page: 1,
				search: null,
			},
			rowDetail: {},
			rowDetailId: null,
			rowDetailName: '',
			rowId: null,
			rowsIds: [],
			rowIdsModules: [],
			rowIdSeat: null,
			rowName: '',
			rowSelected: {},
			rowsSelected: [],
			rucSubsidiary: null,
			seatDetails: [],
			seccionHeader: {
				balance: null,
				currencySymbol: null,
				should: null,
				toHave: null,
			},
			search: null,
			showHeadingBtn: false,
			showSeatForm: false,
			states: [
				{ id: 1, name: 'Correctos' },
				{ id: 2, name: 'Pendientes' },
			],
			subsidiaries: [],
			toDeclare: false,
			modulesFilter: [],
			flagCostCenter: false,
			flagSquareSeats: false,
			flagCancel: true,
			flagValidCostCenter: false,
			indexRowDetail: null,
			isSquareAmounts: false,
			// Variales usadas en la clonación
			dataSeatClone: {},
			showPreviewClone: false,
			loadingData: false,
			valuesNotFound: null,
			showDialog: false,
			showDetails: false,
			detailsRegister: null,
			transactionBlockingModule: {},
			itemsBlockedPeriod: [],
			showItemsBlock: false,
		};
	}

	export default {
		name: 'journal',
		beforeDestroy,
		components: {
			actionBar,
			actionSidebar,
			appInputText,
			autocompleteComponent,
			dateComponent,
			headerContent,
			journalCancelForm,
			journalDetail,
			journalDetailDeleteForm,
			journalDetailForm,
			journalFilter,
			appTooltipButton,
			journalFilterBy,
			journalList,
			journalSeatForm,
			slideSearcher,
			journalDetailAdd,
			previewClone,
			closeIcon,
		},
		computed: {
			...mapGetters('subsidiary', [
				'currentSubsidiary',
			]),
			hasActiveFilters() {
				// Retorna true si al menos un filtro tiene un valor significativo
				return (
					this.params.startDate ||
					this.params.endDate ||
					(this.params.status !== undefined && this.params.status !== null) ||
					(this.params.square !== undefined && this.params.square !== null) ||
					this.moduleName
				);
			},
			permsResource,
			canCreate,
			canUpdate,
			canDelete,
			canWrite,
			accountingName,
			actionsDisabled,
			disabledFormClean,
			disabledFormSave,
			typeDetail,
			disabledCostCenter,
			disabledBtnAdd,
			validInsertCostCenter,
			validButtonCostCenter,
		},
		created,
		data,
		methods: {
			addDetail,
			removeItem,
			addIcon,
			getSquareLabel,
			getModuleLabel,
			getStatusLabel,
			addDetailSeat,
			cleanAll,
			isActionCode,
			saveAccouting,
			addRecord,
			changePageRecords,
			changeAmount,
			closeDialog,
			closeModal,
			currencySymbol,
			deleteJournal,
			createAction,
			createDetailSeat,
			confirmCancel,
			filterBy,
			inlineEditDetail,
			loadAccounts,
			loadCostCenters,
			loadDetail,
			loadModules,
			loadRecords,
			loadStates,
			searchFilterJournal,
			onAction,
			onClean,
			onClick,
			onClickIcon,
			onDelete,
			onDeleteSeat,
			onDeleteSeatMultiple,
			onDeleteSeatInline,
			onEditHeading,
			onInput,
			onInputDetail,
			onKeyPress,
			onPage,
			onSave,
			onSaveDetail,
			onSaveMultiple,
			onSearch,
			onSearchDetail,
			onSearchRecords,
			onSelectedAll,
			onTableOption,
			detailJournalList,
			openSearcher,
			openDetail,
			returnJournal,
			rowIsSelected,
			runAction,
			saveDetailSeat,
			setHeadingData,
			setId,
			setModel,
			subsidiaryChange,
			clickFilter,
			clearFilter,
			clearFilterMobile,
			mobileDetail,
			closeMobile,
			seeDetail,
			selectDetail,
			setCostCenter,
			setData,
			changeDate,
			setModelData,
			setModuleData,
			setDataDetail,
			saveAllDetailsEdits,
			formatData,
			saveNewDetailSeat,
			clearModels,
			onDeleteDetailSeat,
			validateAmountActions,
			cancelEditionDetail,
			cloneSeat,
			buildSeatPreview,
			confirmClone,
			closePreview,
			printSeat,
			closeModelDelete,
			importExcel,
			disguiseWait,
			handleFileUpload,
			readingBookExcel,
			proccessRowExcel,
			totalSelecion,
			createNewObjAccount,
			createNewObjCostCenter,
			closeAlert,
			onDownloadFormat,
			detailDocument,
			closeDetailDocument,
			getLabelRegister,
			closItemsBlock,
		},
		mounted,
		props: {
			subsidiaryId: [Number, String],
		},
		watch: {
			currentSubsidiary: subsidiaryChange,
			rowSelected: {
				handler(newVal, oldVal) {
					if (newVal !== oldVal) {
						this.openDetailSeat = false;
						this.modelDetail = {
							accountingAccountId: null,
							account: null,
							concept: '',
							reference: '',
							costCenterId: null,
							amount: null,
						};
						this.accountingAccount = {};
						this.editDetailInline = false;
					}
				},
			},
		},
	};
</script>

<style lang="scss" scoped>
/* ===== CONTENEDOR PRINCIPAL (ELEGANTE) ===== */
/* =============================================================
   page-journal · bloque <style lang="scss" scoped> completo
   Reemplaza el actual. Se conservan TODAS las clases que usa el
   template; solo cambian los valores visuales.
   ============================================================= */

$jr-ink: #16222b;
$jr-ink-2: #5b6b76;
$jr-muted: #90a0aa;
$jr-line: #e3e9ec;
$jr-plane: #f4f7f8;
$jr-teal: #02979b;
$jr-teal-dark: #017e82;
$jr-teal-soft: #e8f5f5;
$jr-red: #e5484d;
$jr-blue: #77a1d1;

/* ===== BARRA DE FILTROS ===== */
.filters-wrapper {
	margin: 10px 0 4px;
	padding: 0 20px;
}

.filters-bar {
	align-items: center;
	background: #ffffff;
	border: 1px solid $jr-line;
	border-radius: 12px;
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	min-height: 44px;
	padding: 8px 12px;
}

.filter-title-section {
	align-items: center;
	display: flex;
	margin-right: 4px;
}

.filter-title {
	color: $jr-ink-2;
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.9px;
	text-transform: uppercase;
}

.filter-title-section .v-icon {
	color: $jr-teal !important;
}

/* cada filtro */
.filter-pill {
	align-items: baseline;
	background: $jr-plane;
	border: 1px solid $jr-line;
	border-radius: 999px;
	display: inline-flex;
	gap: 6px;
	height: 26px;
	padding: 0 12px;
	transition: border-color 0.15s;
}

.filter-pill--active {
	background: $jr-teal-soft;
	border-color: #bfe3e4;

	.filter-value {
		color: $jr-teal-dark;
	}
}

.filter-label {
	color: $jr-ink-2;
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.6px;
	text-transform: uppercase;
}

.filter-value {
	color: $jr-ink;
	font-size: 12px;
	font-weight: 700;
}

.filters-bar__clear {
	background: none;
	border: 1px solid $jr-line;
	border-radius: 999px;
	color: $jr-ink-2;
	cursor: pointer;
	font-size: 11px;
	font-weight: 700;
	height: 26px;
	margin-left: auto;
	padding: 0 12px;

	&:hover {
		background: $jr-plane;
	}
}

@media (max-width: 768px) {
	.filters-wrapper {
		padding: 0 12px;
	}

	.filter-title-section {
		justify-content: center;
		width: 100%;
	}

	.filter-pill {
		flex: 0 0 calc(50% - 4px);
		justify-content: center;
	}

	.filters-bar__clear {
		margin: 4px auto 0;
	}
}

@media (max-width: 400px) {
	.filter-pill {
		flex: 0 0 100%;
	}
}

/* ===== BOTONES DE MODAL ===== */
.btn-modal {
	border-radius: 8px;
	color: map-get($colors, white);
	font-size: 12.5px;
	font-weight: 700;
	height: 34px;
	padding: 0 22px;
	width: auto;
	min-width: 92px;
}

.save {
	background-color: $jr-teal;

	&:hover {
		background-color: $jr-teal-dark;
	}
}

.cancel {
	background-color: #ffffff;
	border: 1px solid $jr-line;
	color: $jr-ink-2;

	&:hover {
		background-color: $jr-plane;
	}
}

/* ===== LISTADO ===== */
.content-journal-heading {
	padding-left: 20px;
	position: relative;

	@media (max-width: 768px) {
		left: 0px;
		padding-left: 0;
		position: absolute;
		width: 100%;
		z-index: 1 !important;
	}
}

/* ===== PANEL DE DETALLE (derecha) ===== */
.content-detail {
	background-color: #ffffff;
	border: 1px solid $jr-line;
	border-radius: 12px;
	box-shadow: 0 1px 2px rgba(22, 34, 43, 0.04), 0 8px 24px rgba(22, 34, 43, 0.05);
	float: left;
	height: calc(100vh - 150px);
	overflow-x: hidden;
	overflow-y: auto;
	position: fixed;
	right: 16px;
	top: 135px;
	width: 46%;

	/* Laptops / tablets: el panel deja de ser fijo y fluye debajo/al costado
	   de la lista para no encimarse. */
	@media (max-width: 1263px) and (min-width: 769px) {
		height: auto;
		margin-top: 16px;
		position: static;
		right: auto;
		top: auto;
		width: 100%;
	}

	@media (max-width: 768px) {
		border-radius: 0;
		left: -100%;
		position: absolute;
		transition: all .2s ease-in-out 0s;
		width: 100%;
		z-index: 2;

		&.open {
			left: 0;
		}
	}
}

/* cabecera de bloque dentro del panel */
.title-heading {
	background-color: $jr-plane;
	border-bottom: 1px solid $jr-line;
	color: $jr-ink-2;
	font-family: font(AvenirBold);
	font-size: 10px;
	font-weight: 700;
	height: 30px;
	letter-spacing: 0.9px;
	line-height: 30px;
	padding: 0 14px;
	text-align: left;
	text-transform: uppercase;
}

.body-seat-form {
	background-color: #ffffff;
	padding: 12px 14px;
}

.background-heading {
	background-color: $jr-plane;
	padding-left: 20px;
}

/* ===== CHIPS DE TOTALES ===== */
.should-color {
	background-color: $jr-teal;
	border-radius: 8px;
	height: 31px;

	@media (max-width: 768px) {
		display: none;
		font-size: 11px;
		width: 194px;
	}

	.debitV {
		color: white;
		font-family: 'AvenirRegular';
		font-size: 13px;
		font-weight: 700;
		height: 20px;
		letter-spacing: normal;
		line-height: 1.54;
		text-align: center;
		width: 174px;
	}
}

.content-blue {
	background-color: $jr-teal;
	border-radius: 8px;
	color: #ffffff;

	.debitV {
		color: white;
		font-family: 'AvenirRegular';
		font-size: 13px;
		font-weight: 700;
		height: 20px;
		line-height: 1.54;
		text-align: center;
		width: 174px;
	}
}

.content-red {
	background-color: $jr-red;
	border-radius: 8px;
	color: #ffffff;

	.debitC {
		color: white;
		font-family: 'AvenirRegular';
		font-size: 13px;
		font-weight: 700;
		height: 20px;
		line-height: 1.54;
		text-align: center;
		width: 174px;
	}
}

.content-gray {
	background-color: $jr-blue;
	border-radius: 8px;
	color: #ffffff;

	.debitB {
		color: white;
		font-family: 'AvenirRegular';
		font-size: 13px;
		font-weight: 700;
		height: 20px;
		line-height: 1.54;
		text-align: center;
		width: 174px;
	}
}

.background-balance {
	color: white;
	font-family: map-get($fonts, AvenirBold);
	font-size: 12px;
	padding: 5px 17px;
}

.height-input {
	min-height: 26px;
	padding-top: 3px;
}

.background-gray-mobile {
	background-color: $jr-plane;
	padding: 5px 19px;
}

.color-blue {
	color: $jr-teal;
	font-family: map-get($fonts, AvenirDemi);
	font-size: map-get($sizes, small);
}

.color-red {
	color: $jr-red;
	font-family: map-get($fonts, AvenirDemi);
	font-size: map-get($sizes, small);
}

.titleCard {
	background-color: $jr-teal !important;
	@include flex-between;
}

.createSeat {
	border-radius: 10px;
}

.CardSeat {
	border-radius: 12px;
}

.btnCloseDialog {
	background-color: $jr-red;
	height: 20px;
	margin: 0;
	width: 20px;
}

.mobile-none {
	@media (max-width: 768px) {
		display: none;
	}
}

.btn-clear-filter {
	background-color: map-get($colors, text-red-light);
	border-radius: 999px;
	color: map-get($colors, white);
	font-size: 12px;
	font-weight: 700;
	padding: 5px 14px;

	@media (min-width: 768px) {
		display: none;
	}
}

.jr-cargando-overlay {
	align-items: center;
	background: rgba(14, 42, 48, 0.42);
	bottom: 0;
	display: flex;
	justify-content: center;
	left: 0;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 1000;
}

.jr-cargando {
	align-items: center;
	background: #ffffff;
	border-radius: 14px;
	box-shadow: 0 18px 50px rgba(8, 30, 35, 0.28);
	display: flex;
	flex-direction: column;
	justify-content: center;
	max-width: 330px;
	padding: 34px 28px 30px;
	text-align: center;
	width: calc(100% - 32px);
}

.jr-cargando__aro {
	height: 54px;
	margin-bottom: 22px;
	position: relative;
	width: 54px;
}

.jr-cargando__aro::before,
.jr-cargando__aro::after {
	border-radius: 50%;
	content: '';
	inset: 0;
	position: absolute;
}

.jr-cargando__aro::before {
	border: 3px solid rgba(2, 151, 155, 0.16);
}

.jr-cargando__aro::after {
	animation: jr-giro 0.9s linear infinite;
	border: 3px solid transparent;
	border-right-color: #02979b;
	border-top-color: #02979b;
}

.jr-cargando__icono {
	align-items: center;
	display: flex;
	height: 100%;
	justify-content: center;
	width: 100%;

	.v-icon {
		color: #02979b !important;
		font-size: 22px !important;
	}
}

.jr-cargando__titulo {
	color: $jr-ink-2;
	font-size: 16px;
	font-weight: 600;
	letter-spacing: 0.2px;
	margin: 0;
}

.jr-cargando__texto {
	color: #7b8c96;
	font-size: 12.5px;
	margin: 6px 0 0;
}

.jr-cargando__barra {
	background: rgba(2, 151, 155, 0.14);
	border-radius: 999px;
	height: 3px;
	margin-top: 22px;
	overflow: hidden;
	position: relative;
	width: 170px;
}

.jr-cargando__barra::after {
	animation: jr-avance 1.4s ease-in-out infinite;
	background: #02979b;
	border-radius: 999px;
	content: '';
	height: 100%;
	left: 0;
	position: absolute;
	top: 0;
	width: 45%;
}

@keyframes jr-giro {
	to {
		transform: rotate(360deg);
	}
}

@keyframes jr-avance {
	0% {
		transform: translateX(-100%);
	}

	100% {
		transform: translateX(240%);
	}
}

/* ===== MODAL DE CUENTAS NO ENCONTRADAS ===== */
.card-container {
	display: flex;
	flex-direction: column;
	padding: 6px;

	&-title {
		align-items: center;
		display: flex;
		justify-content: flex-end;
		padding: 2px;
	}

	&-list {
		color: $jr-ink-2;
		font-size: 13px;
		line-height: 1.5;
		padding: 4px 6px 10px;

		ul {
			margin: 4px 0 0 18px;
		}

		li {
			color: $jr-ink;
			font-weight: 600;
		}
	}
}

/* ===== MODAL DE ASIENTOS BLOQUEADOS ===== */
.card-container-blocked {
	background-color: white;
	border-radius: 12px;

	&-text {
		display: flex;
		flex-direction: column;
		padding: 16px;

		&-title {
			color: $jr-ink;
			font-size: 14px;
			font-weight: 700;
			margin-bottom: 10px;
		}

		&-list {
			display: flex;
			flex-direction: column;
			max-height: 350px;
			overflow-y: auto;
			scroll-behavior: smooth;
		}
	}

	&-actions {
		border-top: 1px solid $jr-line;
		display: flex;
		gap: 1rem;
		justify-content: flex-end;
		padding: 12px 16px;
	}
}

.card {
	animation: cardFadeIn 0.25s ease-out;
	background: #ffffff;
	border: 1px solid $jr-line;
	border-left: 3px solid $jr-red;
	border-radius: 10px;
	margin-bottom: 8px;
	padding: 10px 14px;
	transition: box-shadow 0.2s ease;

	&:last-child {
		margin-bottom: 0;
	}

	&:hover {
		box-shadow: 0 4px 14px rgba(22, 34, 43, 0.08);
	}
}

@keyframes cardFadeIn {
	from {
		opacity: 0;
		transform: translateY(8px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.card-header {
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 4px;
}

.card-title {
	color: $jr-ink;
	font-size: 12.5px;
	font-weight: 700;
	line-height: 1.4;
	margin: 0;
}

.card-body {
	display: flex;
	flex-direction: column;
	margin-bottom: 0;
}

.card-description {
	color: $jr-ink-2;
	font-size: 11.5px;
	line-height: 1.5;
}

/* ===== MODAL DETALLE DEL REGISTRO ===== */
.card-container-details {
	background-color: white;
	border-radius: 14px !important;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding: 0;

	&-title {
		align-items: center;
		background-color: $jr-teal;
		color: #ffffff;
		display: flex;
		font-size: 14px;
		font-weight: 700;
		justify-content: space-between;
		padding: 12px 16px;
	}

	&-list {
		padding: 0 !important;
	}
}

.doc-hero {
	align-items: center;
	background-color: $jr-plane;
	border-bottom: 1px solid $jr-line;
	display: flex;
	justify-content: space-between;
	padding: 14px 18px;
}

.doc-label {
	color: $jr-ink-2;
	display: block;
	font-size: 9.5px;
	font-weight: 700;
	letter-spacing: 0.9px;
	text-transform: uppercase;
}

.doc-hero__number {
	display: block;
	font-size: 18px;
	font-weight: 700;
	margin-top: 2px;
}

.doc-hero__chips {
	display: flex;
	margin-top: 6px;
}

.doc-chip {
	background-color: #ffffff;
	border: 1px solid $jr-line;
	border-radius: 999px;
	color: $jr-ink-2;
	font-size: 10.5px;
	font-weight: 700;
	margin-right: 6px;
	padding: 2px 10px;
}

.doc-chip--module {
	background-color: $jr-teal;
	border-color: $jr-teal;
	color: #ffffff;
}

.doc-hero__amount {
	text-align: right;
	white-space: nowrap;
}

.doc-hero__value {
	display: block;
	font-size: 24px;
	font-weight: 700;
}

/* pares etiqueta / valor */
.content-green {
	color: $jr-ink-2;
	display: block;
	font-family: font(open-bold);
	font-size: 9.5px;
	font-weight: 700;
	letter-spacing: 0.9px;
	min-width: 0;
	padding: 0;
	text-transform: uppercase;
	background: none;
}

.c-text-green {
	background: none;
	color: $jr-ink;
	display: block;
	font-family: font(open-regular);
	font-size: 13px;
	font-weight: 600;
	overflow: hidden;
	padding: 0;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: 100%;
}

.doc-item {
	border-bottom: 1px solid $jr-line;
	border-right: 1px solid $jr-line;
	min-width: 0;
	padding: 11px 18px;
}

.doc-item--wide {
	border-right: none;

	.c-text-green {
		white-space: normal;
	}
}

.doc-card__foot {
	display: flex;
	justify-content: flex-end;
	padding: 12px 16px;
}

.cursor-pointer {
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/journal/page-journal.vue